export default {
  translation: {
    commonUsedWords: {
      login: 'Iniciar sessão',
      email: 'Endereço de e-mail',
      password: 'Senha',
      emailIsRequired: 'O e-mail é obrigatório',
      mustBeAValidEmail: 'Deve ser um e-mail válido!',
      deviceSerialNumber: 'Número de série do dispositivo',
      next: 'Próximo',
      success: 'Sucesso',
      submit: 'Enviar',
      firstName: 'Primeiro nome',
      firstNameIsRequired: 'O primeiro nome é obrigatório',
      lastName: 'Sobrenome',
      lastNameIsRequired: 'O sobrenome é obrigatório',
      save: 'Salvar',
      delete: 'Excluir',
      undoChanges: 'Desfazer alterações',
      cancel: 'Cancelar',
      loading: 'Carregando...',
      yes: 'Sim',
      no: 'Não',
      clear: 'Limpar',
      confirm: 'Confirmar',
      noOption: 'Sem opções',
      noCompressorTemplatesFound: 'Nenhum modelo de compressor encontrado',
      openText: 'Abrir',
      edit: 'Editar',
      logout: 'Sair',
      update: 'Atualizar',
      locked: 'Bloqueado',
      unlocked: 'Desbloqueado',
      latitude: 'Latitude (LAT)',
      longitude: 'Longitude (LONG)',
      ok: 'OK',
      okay: 'Certo',
      done: 'Concluído',
      comingSoon: 'Em breve...',
      reset: 'Redefinir',
      attention: 'Atenção',
      note: 'Nota',
      continue: 'Continuar',
      finish: 'Concluir',
    },
    api: {
      auth: {
        fieldsAreMissing: 'Campos obrigatórios estão ausentes',
        userNotFound: 'Usuário não encontrado',
        missingRefreshToken: 'Token de atualização ausente',
        cannotRefreshToken: 'Não é possível atualizar o token',
      },
      helpers: {
        error: 'Erro',
        invalidHTTPMethod: 'Método HTTP inválido',
      },
    },
    components: {
      autocompleteField: {
        presets: 'Predefinições',
        results: 'Resultados',
      },
      confirmEmail: {
        confirmEmail: 'Confirmar endereço de e-mail',
        confirmEmailIsRequired: 'A confirmação do e-mail é obrigatória',
        emailNotMatched: 'As entradas de e-mail não coincidem',
      },
      confirmPassword: {
        confirmPassword: 'Confirmar senha',
        confirmPasswordIsRequired: 'A confirmação da senha é obrigatória',
        newPasswordIsRequired: 'A nova senha é obrigatória',
        showPassword: 'Mostrar senha',
        passwordLength: 'As senhas devem ter pelo menos 6 caracteres',
        passwordContainSpaces: 'A senha não deve conter espaços',
        passwordNotMatch: 'As senhas não coincidem',
        newPassword: 'Nova senha',
      },
      confirmModal: {
        areYouSure: 'Você tem certeza?',
      },
      appliedFilters: {
        between: 'Entre {{firstValue}} e {{secondValue}}',
        bottom: 'Inferior {{primaryValue}}%',
        top: 'Superior {{primaryValue}}%',
        activeFilters: 'Filtros ativos',
        active: 'ativo',
        closed: 'fechado',
      },
      editTable: {
        editTable: 'Editar tabela',
        selectDeselect: 'Selecionar / Desmarcar valores da tabela',
        resetToDefault: 'Restaurar para o padrão',
      },
      errorBoundary: {
        oops: 'Ops! Algo inesperado aconteceu.',
        tryAgain: 'Por favor, tente novamente! Se o problema persistir, entre em contato com o administrador.',
        refresh: 'Atualizar',
      },
      noResultFound: {
        noResultFoundTryAgain: 'Desculpe, nenhum resultado encontrado. Por favor, tente novamente.',
      },
      permissionGuard: {
        invalidPermission: 'Estrutura de permissão inválida, esperados 3 elementos no array',
      },
      preview: {
        findInView: 'Encontrar na visualização',
        showDetails: 'Mostrar detalhes',
        closeEsc: 'Fechar (Esc)',
        prevLeftArrow: 'Anterior (Seta para a esquerda)',
        nextRightArrow: 'Próximo (Seta para a direita)',
        proceedWithoutSaving: 'Navegar sem salvar',
        continueEditing: 'Continuar editando',
        unsavedChanges: {
          partTwo: 'Você tem ',
          partThree: 'ALTERAÇÕES NÃO SALVAS',
          partFour: '. Navegar sem salvar descartará todas as alterações. Você tem certeza?',
        },
      },
      printRecord: {
        title: 'Registro',
        date: 'Data:',
        location: 'Localização',
        leakDetails: 'Detalhes',
        leakParameters: 'Parâmetros',
        energyLoss: 'Perda de energia',
        leakSourceEquipment: 'Equipamento de origem',
        notes: 'Notas',
        leakEventStatus: 'Status',
        requiredAction: 'Ação necessária',
        leakSourceImage: 'Imagem de origem',
        smartLeakTag: 'Etiqueta inteligente',
        workRef: 'Ref. de trabalho',
        lossPerYear: 'Perda ({{currency}}/ano)',
        costOfEnergy: 'Custo da energia ({{currency}}/kWh)',
      },
      assignedAction: {
        actionHeader: {
          deleteAssignmentSuccess: 'A atribuição foi excluída',
          deleteAssignmentError: 'A atribuição não pode ser excluída. Por favor, tente novamente mais tarde',
          currentlyAssigned: 'Ação atualmente atribuída',
          repairedBy: 'Reparado por',
          text: 'Você vai excluir esta atribuição. Esta ação não pode ser desfeita',
        },
        actionSaveDate: 'Última vez salvo',
      },
      visibleColumnsPopper: {
        tableValues: 'Selecionar / Desmarcar valores da tabela',
      },
      tableHead: {
        deselectCurrentPage: 'Desmarcar página atual',
        selectCurrentPage: 'Selecionar página atual',
      },
      coverPage: {
        title: 'Relatório de Registros',
        reportDate: 'Data do relatório: {{date}}',
        poweredBy: 'Desenvolvido por {{companyName}}',
        date: 'Período: {{from}} - {{to}}',
        includedRecords: 'Registros incluídos: {{count}}',
        totalLoss: 'Perda total',
        lossByCurrency: '{{currency}}: {{loss}}',
        totalKwhLoss: 'Perda total em kWh: {{kwh}} kWh/ano',
      },
      tagsCoverPage: {
        title: 'Relatório de Tags inteligentes',
        reportDate: 'Data do relatório: {{date}}',
        poweredBy: 'Desenvolvido por {{companyName}}',
        date: 'Período: {{from}} - {{to}}',
        includedTags: 'Tags inteligentes incluídas: {{count}}',
        includedRecords: 'Registros incluídos: {{count}}',
        totalKwhLoss: 'Perda total em kWh: {{kwh}} kWh/ano',
      },
      EnergyEfficiencyGauge: {
        title: 'Classificação de eficiência energética',
        recommendedRange: 'Faixa de eficiência recomendada',
        levels: {
          good: {
            label: 'Boa',
            description:
              'Seu sistema opera próximo ao seu potencial ideal e mais eficiente. Compressor moderno e de alta eficiência (ex.: acionamento de velocidade variável ou parafuso rotativo totalmente carregado no ponto de projeto)',
          },
          average: {
            label: 'Média',
            description:
              'Seu sistema apresenta ineficiências típicas; há espaço para melhoria. Sistema industrial típico, possivelmente com equipamentos mais antigos ou operando em grande parte em carga parcial com controles menos eficientes (ex.: carga/descarga)',
          },
          poor: {
            label: 'Ruim',
            description:
              'Seu sistema é altamente ineficiente (provavelmente devido a vazamentos, equipamentos antigos ou eletricidade cara) e precisa de atenção imediata. Sistema antigo e mal mantido, ou que opera com ineficiência extrema em carga parcial (ex.: vários compressores funcionando de forma não otimizada)',
          },
        },
      },
    },
    constants: {
      qualifiers: {
        EQUAL_TO: 'Igual a',
        LESS_THAN: 'Menor que',
        GREATER_THAN: 'Maior que',
        LESS_THAN_OR_EQUAL_TO: 'Menor ou igual a',
        GREATER_THAN_OR_EQUAL_TO: 'Maior ou igual a',
        BETWEEN_A_AND_Y: 'Entre',
        TOP_PERCENT: 'Top "x"%',
        BOTTOM_PERCENT: 'Inferior "x"%',
      },
      recordFields: {
        CREATED_AT: 'Criado em',
        RECORD_ID: 'Número de ID do registro',
        DOCUMENT_ID: 'Número de ID do registro',
        DOLLARS_PER_YEAR: 'Perda',
        GAS_COMPONENT: 'Gás/Componente',
        LEAK_TYPE: 'Perfil de tipo',
        DATE_TIME: 'Data/Hora de criação',
        DB_PEAK: 'Pico dB',
        COMPANY: 'Empresa',
        NOTES: 'Notas',
        USER: 'Usuário',
        EQUIPMENT_TAG: 'Etiqueta do equipamento/componente',
        FLOW: 'Fluxo (m³/h)',
        EQUIPMENT: 'Unidade/Equipamento',
        ROUTE: 'Rota',
        ROUTE_LOCATION: 'Local da rota',
        PROJECT_SURVEY: 'Ref. de auditoria/inspeção',
        OUTAGE_STATUS: 'É necessário desligamento/interrupção?',
        FACILITY: 'Instalação/Site',
        ACTION_STATUS: 'Status da ação',
        SERVICE_TYPE: 'Serviço/Tipo',
        DB_ACTIVE: 'dB ativo',
        REFERENCE_ID: 'Projeto nº / ID da inspeção',
        AMBIENT_TEMPERATURE: 'Temperatura ambiente (°C)',
        LEAK_PRESSURE: 'Pressão (kPag)',
        LEAK_TEMPERATURE: 'Temperatura do gás (°C)',
        LEAK_CATEGORY: 'Categoria',
        DISTANCE: 'Distância (m)',
        GAS_COST: 'Custo do gás ($/m³)',
        COMPRESSOR_FLOW: 'm³/h por BHP',
        DEVICE_ID: 'ID do dispositivo',
        COMPRESSOR_BHP: 'BHP do compressor',
        COMPRESSOR_TYPE: 'Tipo de compressor',
        MOTOR_EFFICIENCY: 'Eficiência do motor (%)',
        ENERGY_COST: 'Custo de energia ($/kWh)',
        HOURS: 'Horas de funcionamento/ano',
        LOCATION: 'Localização',
        LAST_MODIFIED: 'Data/Hora da última gravação',
        POWER_LOAD: '% da carga total de energia',
        CLIENT: 'Cliente',
        SERVICE: 'Serviço',
        CAPACITY: '% de capacidade',
        EQUIPMENT_TYPE: 'Tipo de equipamento/componente',
        SMART_TAG: 'Etiqueta inteligente nº',
        WORK_REF: 'Ref. de trabalho nº',
        REPAIRED_BY: 'Reparado por',
        ALTITUDE: 'Altitude (m)',
        REQUIRED_ACTION: 'Ação necessária',
        FREQUENCY_LOW_BOUND: 'Frequência (Baixa)',
        FREQUENCY_HIGH_BOUND: 'Frequência (Alta)',
        SENSITIVITY: 'Sensibilidade',
        KWH_PER_YEAR: 'kWh/ano',
        ASSIGNED_BY: 'Atribuído por',
        ASSIGNED_TO: 'Atribuído a',
        ASSIGNED_DATE: 'Data da atribuição',
        LOSS_PER_YEAR: 'Perda (por ano)',
        ASSIGNED: 'Atribuído',
        CREATOR_USER_ID: 'ID do usuário',
        CURRENCY: 'Moeda',
        COMPLETED_ON: 'Concluído em',
        IMAGES: 'Imagens de origem',
        ACTION_STATUS_MODIFIED: 'Status da ação modificado',
        TYPE: 'Tipo',
      },
      electricalRecordFields: {
        REGION: 'Região',
        LOCATION_TYPE: 'Tipo de local',
        VOLTAGE: 'Voltagem',
        PHASE: 'Fase',
        FREQUENCY: 'Frequência',
        ELECTRICAL_EQUIPMENT_TAG: 'Equipamento/Componente',
        ELECTRICAL_EQUIPMENT_TYPE: 'Tipo de equipamento/componente',
        FAULT_TYPE: 'Tipo de falha',
        ELECTRICAL_NOTES: 'Notas',
      },
      IMPERIAL_LABELS: {
        FLOW: 'Fluxo (cfm)',
        AMBIENT_TEMPERATURE: 'Temperatura ambiente (°F)',
        LEAK_PRESSURE: 'Pressão (psi)',
        LEAK_TEMPERATURE: 'Temperatura do gás (°F)',
        DISTANCE: 'Distância (ft)',
        GAS_COST: 'Custo do gás ($/ft³)',
        COMPRESSOR_FLOW: 'cfm por BHP',
        ALTITUDE: 'Altitude (ft)',
      },
      userFields: {
        EMAIL: 'E-mail',
        ROLE: 'Função',
        DEVICE_ID: 'ID do dispositivo',
        SUBSCRIPTION_RENEWAL_DATE: 'Data de renovação da assinatura',
        DATE_TIME: 'Criado em',
        ACTIVE: 'Status',
        SOFTWARE_VERSION: 'Versão do software',
        FIRMWARE_VERSION: 'Versão do firmware',
        FIRST_NAME: 'Primeiro nome',
        LAST_NAME: 'Sobrenome',
        COMPANY_SLUG: 'Empresa',
        COMPANY_NAME: 'Empresa',
      },
      auditFields: {
        documentId: 'Número de ID do registro',
        companyName: 'Nome da empresa',
        auditorName: 'Nome do auditor',
        auditorEmail: 'E-mail do auditor',
        createdAt: 'Criado em',
        updatedAt: 'Atualizado em',
        comment: 'Comentários',
        isLocked: 'Bloqueio de auditoria',
      },
      deviceFields: {
        DEVICE_ID: 'ID do dispositivo',
        ACTIVE: 'Status',
        REGISTERED_ON: 'Ativado em',
        EVENT_COUNT: 'Registros',
        UNIQUE_COMPANIES: 'Empresas',
        LAST_USED_AT: 'Último uso em',
        LAST_USED_BY_NAME: 'Último nome usado',
        LAST_USED_BY_EMAIL: 'Último e-mail usado',
        LOCATION: 'Última localização usada',
        FIRMWARE_VERSION: 'Versão do firmware',
      },
      statsFields: {
        labels: {
          TIMELINE: 'Linha do tempo',
          CRITERIA: 'Critérios',
        },
        timeline: {
          LAST_3_MONTHS: 'Últimos 3 meses',
          LAST_6_MONTHS: 'Últimos 6 meses',
          LAST_12_MONTHS: 'Últimos 12 meses',
          YEAR_TO_DATE: 'Ano até a data',
          ALL_TIME: 'Todo o período',
        },
        criteria: {
          LOSS: 'Perda',
          FLOW: 'Fluxo',
          KWH: 'kWh',
        },
      },
      enpisFields: {
        labels: {
          NO_OF_LEAKS_FOUND: '# Vazamentos encontrados',
          NO_OF_LEAKS_REPAIRED: '# Vazamentos reparados',
          PERCENT_LEAKS_REPAIRED: '% Vazamentos reparados',
          VOL_FLOW_FOUND: 'Fluxo volumétrico encontrado (m³/h)',
          VOL_FLOW_REPAIRED: 'Fluxo volumétrico reparado (m³/h)',
          PERCENT_VOL_FLOW_REPAIRED: '% Fluxo volumétrico reparado',
          VALUE_FOUND: 'Valor encontrado',
          VALUE_REPAIRED: 'Valor reparado',
          ENERGY_SAVING_OPPORTUNITY_FOUND: 'Oportunidade de economia de energia (Encontrada) (kWh)',
          ENERGY_SAVING_OPPORTUNITY_PERCENT: 'Oportunidade de economia de energia % (Encontrada vs calculada ou medida)',
          ENERGY_SAVING_REALIZED_FIXED: 'Economia de energia realizada (Corrigida) (kWh)',
          ENERGY_SAVING_REALIZED_PERCENT: 'Economia de energia realizada % (Corrigida vs calculada ou medida)',
          SYSTEM_CONTROL_PRESSURE_REDUCED: 'Pressão de controle do sistema reduzida (kPag)',
        },
        labelsImperial: {
          VOL_FLOW_FOUND: 'Fluxo volumétrico encontrado (cfm)',
          VOL_FLOW_REPAIRED: 'Fluxo volumétrico reparado (cfm)',
          ENERGY_SAVING_OPPORTUNITY_FOUND: 'Oportunidade de economia de energia (Encontrada) (BTU)',
          ENERGY_SAVING_REALIZED_FIXED: 'Economia de energia realizada (Corrigida) (BTU)',
          SYSTEM_CONTROL_PRESSURE_REDUCED: 'Pressão de controle do sistema reduzida (psi)',
        },
        columns: {
          PERFORMANCE_INDICATOR: 'Performance Indicator',
          ENPI_VALUE: 'EnPI Value',
          ENB_VALUE: 'EnB Value',
          SUCCESS_THRESHOLD: 'Success Threshold (%)',
        },
      },
      companiesFields: {
        labels: {
          NAME: 'Nome',
          COUNTRY_ID: 'País',
          CURRENCY: 'Moeda',
          LANGUAGE: 'Idioma',
          INDUSTRY: 'Indústria',
        },
      },
      assignedAction: {
        assignedTo: 'Atribuído a',
        assignedBy: 'Atribuído por',
        assignedDate: 'Data da atribuição',
        requestReassign: 'Solicitar reatribuição',
        actionStatus: 'Status da ação',
        partsNeeded: 'Peça necessária',
        productionOutage: 'Solicitado desligamento',
        timeToRepair: 'Tempo de reparo',
        repairCost: 'Custo do reparo',
        closeOutRef: 'Ref. de encerramento',
        'assignmentRecord.documentId': 'ID do registro',
        assignmentId: 'ID da atribuição',
        owner: 'Responsável',
        companyName: 'Empresa',
        assignmentActive: 'Status da atribuição',
        'assignmentRecord.leakStatus.building': 'Unidade/Equipamento',
        'assignmentRecord.leakStatus.facility': 'Instalação',
        'assignmentRecord.leakStatus.routeName': 'Rota',
        'assignmentRecord.leakStatus.smartTag': 'Etiqueta inteligente nº',
        'assignmentRecord.leakStatus.workRef': 'Ref. de trabalho nº',
        'assignmentRecord.currency': 'Moeda',
      },
      AAR_FIELD_LABEL: {
        NOTES: 'Ação tomada',
        CLOSE_OUT_REF: 'Ref. de encerramento da ação nº',
        PARTS_NEEDED: 'Nova peça/componente necessário',
        PRODUCTION_OUTAGE: 'Produção interrompida',
        REPAIR_COST: 'Custo ($)',
        REQUEST_REASSIGN: 'Solicitar reatribuição',
        ACTION_STATUS: 'Status da ação',
        TIME_TO_REPAIR: 'Tempo de reparo (min)',
      },
      leak: {
        chartsLabels: {
          FLOW_BY_LEAK: 'Fluxo por categoria de vazamento',
          LOSS_BY_LEAK: 'Perda por categoria de vazamento',
          TAGS_BY_LEAK: 'Etiquetas por categoria de vazamento',
          AVG_FLOW_BY_LEAK: 'Fluxo médio por categoria de vazamento',
          SAVING_OPT_BY_REPAIR: 'Oportunidade e economia por tempo de reparo',
          FLOW_REPAIR_TIME: 'Fluxo por tempo de reparo',
          LOSS_REPAIR_TIME: 'Perda por tempo de reparo',
          FLOW_REPAIR_PROG: 'Fluxo por andamento do reparo',
          TOTAL_REPAIR_PROG: 'Perda por andamento do reparo',
          FLOW_BY_EQUIP_COMP: 'Fluxo por equipamento/componente',
          LOSS_BY_EQUIP_COMP: 'Perda por equipamento/componente',
          TAGS_BY_EQUIP_COMP: 'Etiquetas por equipamento/componente',
        },
        leakCategoryLabels: {
          LOW: 'Baixo',
          MEDIUM: 'Médio',
          HIGH: 'Alto',
        },
        actionStatus: {
          OPEN: 'Aberto',
          COMPLETE: 'Concluído',
        },
        equipmentTypes: {
          CONNECTOR: 'Conector',
          CONTROL_VALVE: 'Válvula de controle',
          HOSE: 'Mangueira',
          TUBE_FITTING: 'Conexão tubular',
          METER: 'Medidor',
          OPEN_ENDED_LINE: 'Linha aberta',
          PRESSURE_RELIEF_VALVE: 'Válvula de alívio de pressão',
          PUMP_SEAL: 'Vedação da bomba',
          REGULATOR: 'Regulador',
          VALVE: 'Válvula',
          LEVEL_CONTROLLER: 'Controlador de nível',
          POSITIONER: 'Posicionador',
          PRESSURE_CONTROLLER: 'Controlador de pressão',
          TRANSDUCER: 'Transdutor',
          GENERIC_PNEUMATIC_INSTRUMENT: 'Instrumento pneumático genérico',
          GENERIC_RECIPROCATING_COMPRESSOR: 'Compressor alternativo genérico',
          GENERIC_CENTRIFUGAL_COMPRESSOR: 'Compressor centrífugo genérico',
        },
        mainGasValues: {
          AIR: 'Ar',
          METHANE: 'Metano (CH4)',
          CARBON_DIOXIDE: 'Dióxido de carbono (CO2)',
          HYDROGEN: 'Hidrogênio (H2)',
          HELIUM: 'Hélio (He)',
          NITROGEN: 'Nitrogênio (N2)',
          REFRIGERANT: 'Refrigerante (HFCs)',
          ARGON: 'Argônio (Ar)',
          OXYGEN: 'Oxigênio (O)',
          WATER: 'Água (Vapor)',
        },
        leakTypeValues: {
          DEFAULT: 'Nenhum selecionado',
          HOLE: 'Furo',
          CRACK: 'Rachadura',
          FITTING: 'Conexão',
          FLANGE: 'Flange',
          'GLAND/SEAL': 'Gaxeta/Vedação',
          THREAD: 'Rosca',
          'TUBE/HOSE': 'Tubo/Mangueira',
        },
        serviceValues: {
          COMPRESSED_AIR: 'Ar comprimido',
          VACUUM: 'Vácuo',
          STEAM: 'Vapor de água',
          PROCESS_GAS: 'Gás de processo',
          LIQUID: 'Líquido',
        },
        compressorTypesValues: {
          ROTARY_SCREW: 'Parafuso rotativo',
          RECIPROCATING: 'Alternativo',
          SCROLL: 'Scroll',
          CENTRIFUGAL: 'Centrífugo',
        },
        regionValues: {
          NORTH_AMERICA: 'América do Norte',
          OUTSIDE_NORTH_AMERICA: 'Exterior à América do Norte',
        },
        locationTypeValues: {
          RESIDENTIAL: 'Residencial',
          COMMERCIAL: 'Comercial',
          INDUSTRIAL: 'Industrial',
          MEDIUM_VOLTAGE: 'Média tensão',
          HIGH_VOLTAGE: 'Alta tensão',
        },
        phaseValues: {
          SINGLE_PHASE: 'Monofásico',
          THREE_PHASE: 'Trifásico',
        },
        faultValues: {
          SELECT_FAULT_TYPE: 'Selecionar tipo de falha',
          KNICKS_OR_VOIDS_IN_INSULATION: 'Cortes ou falhas na isolação',
          CORONA: 'Corona',
          TREEING: 'Arborização elétrica',
          TRACKING: 'Rastreamento elétrico',
          ARCING: 'Arqueamento elétrico',
          'DIRTY_POWER/POWER_DISTORTION': 'Energia suja/Distorção de energia',
          MECHANICAL_LOOSENESS: 'Folga mecânica',
          DELAMINATION_OF_WINDINGS: 'Delaminação dos enrolamentos',
          LOOSE_PANEL: 'Painel solto',
          VIBRATING_NAMEPLATE: 'Placa de identificação vibrando',
          ANTAGONISTIC_ULTRASOUND: 'Ultrassom antagônico',
          OTHER: 'Outro',
        },
        electricEquipmentTypeValues: {
          MCC: 'CCM (Centro de Controle de Motores)',
          'TRANSFORMER,_DRY': 'Transformador a seco',
          'TRANSFORMER,_OIL': 'Transformador a óleo',
          SWITCH_GEAR: 'Cubículo de média/alta tensão (Switchgear)',
          PANEL: 'Painel',
          BUSDUCT: 'Barramento blindado',
          CABLE: 'Cabo',
          CONNECTOR: 'Conector',
          BREAKER: 'Disjuntor',
          BUSHING: 'Isolador',
          TRANSMISSION_LINE: 'Linha de transmissão',
          'TRANSFORMER,_POLE': 'Transformador de poste',
          BATTERY: 'Bateria',
          BATTERY_BANK: 'Banco de baterias',
          TERMINALS: 'Terminais',
          'TRANSFORMER,_STEP_UP': 'Transformador elevador',
          'TRANSFORMER,_STEP_DOWN': 'Transformador abaixador',
          DISTRIBUTION_PANEL: 'Painel de distribuição',
          BREAKER_PANEL: 'Painel de disjuntores',
          RELAYS: 'Relés',
          CAPACITORS: 'Capacitores',
          REACTORS: 'Reatores',
          UPS: 'UPS (No-Break)',
          GROUNDING: 'Aterramento',
          POWER_METERS: 'Medidores de energia',
          CURRENT_TRANSFORMERS: 'Transformadores de corrente',
          POTENTIAL_TRANSFORMERS: 'Transformadores de potencial',
          SURGE_PROTECTION: 'Proteção contra surtos',
          CABLE_TRAYS: 'Bandejas de cabos',
          EMERGENCY_LIGHTING: 'Iluminação de emergência',
          CONTACTORS: 'Contatores',
          INVERTERS: 'Inversores',
          SOLAR_PANELS: 'Painéis solares',
          BATTERY_STORAGE_SYSTEMS: 'Sistemas de armazenamento de baterias',
        },
        recordTypes: {
          leak: 'Vazamento',
          electrical: 'Elétrico',
        },
        labels: {
          LOW: 'Baixo',
          MEDIUM: 'Médio',
          HIGH: 'Alto',
          EQUIPMENT: 'Equipamento',
          SAVINGS: 'Economia',
          OPPORTUNITY: 'Oportunidade',
          LOSS: 'Perda',
          REPAIRED: 'Reparado',
          UNREPAIRED: 'Não reparado',
          LESS_15_DAYS: 'Menos de 15 dias',
          DAYS_16_TO_30: '16 a 30 dias',
          DAYS_31_TO_60: '31 a 60 dias',
          DAYS_61_TO_90: 'Mais de 60 dias',
          LESS_THAN_15_DAYS: 'Reparado < 15 dias',
          '16_TO_30_DAYS': 'Reparado em 16-30 dias',
          '31_TO_60_DAYS': 'Reparado em 31-60 dias',
          MORE_THAN_60_DAYS: 'Reparado em 61-90 dias',
          AIR: 'Ar',
          METHANE: 'Metano (CH4)',
          CARBON_DIOXIDE: 'Dióxido de carbono (CO2)',
          HYDROGEN: 'Hidrogênio (H2)',
          HELIUM: 'Hélio (He)',
          NITROGEN: 'Nitrogênio (N2)',
          REFRIGERANT: 'Refrigerante (HFCs)',
          ARGON: 'Argônio (Ar)',
          OXYGEN: 'Oxigênio (O)',
          WATER: 'Água (Vapor)',
          DEFAULT: 'Nenhum selecionado',
          HOLE: 'Furo',
          CRACK: 'Rachadura',
          FITTING: 'Conexão',
          FLANGE: 'Flange',
          'GLAND/SEAL': 'Gaxeta/Vedação',
          THREAD: 'Rosca',
          'TUBE/HOSE': 'Tubo/Mangueira',
          COMPRESSED_AIR: 'Ar comprimido',
          VACUUM: 'Vácuo',
          STEAM: 'Vapor',
          PROCESS_GAS: 'Gás de processo',
          LIQUID: 'Líquido',
          ROTARY_SCREW: 'Parafuso rotativo',
          RECIPROCATING: 'Alternativo',
          SCROLL: 'Scroll',
          CENTRIFUGAL: 'Centrífugo',
          CONNECTOR: 'Conector',
          CONTROL_VALVE: 'Válvula de controle',
          HOSE: 'Mangueira',
          TUBE_FITTING: 'Conexão de tubo',
          METER: 'Medidor',
          OPEN_ENDED_LINE: 'Linha aberta',
          PRESSURE_RELIEF_VALVE: 'Válvula de alívio de pressão',
          PUMP_SEAL: 'Vedação da bomba',
          REGULATOR: 'Regulador',
          VALVE: 'Válvula',
          LEVEL_CONTROLLER: 'Controlador de nível',
          POSITIONER: 'Posicionador',
          PRESSURE_CONTROLLER: 'Controlador de pressão',
          TRANSDUCER: 'Transdutor',
          GENERIC_PNEUMATIC_INSTRUMENT: 'Instrumento pneumático genérico',
          GENERIC_RECIPROCATING_COMPRESSOR: 'Compressor alternativo genérico',
          GENERIC_CENTRIFUGAL_COMPRESSOR: 'Compressor centrífugo genérico',
        },
        leakRecordPDF: 'Registro • Exportado em {{date}}',
        leakTag: 'Tags inteligentes • Exportado em {{date}}',
      },
      compressorFields: {
        labels: {
          COMPRESSOR_TAG: 'Etiqueta do compressor',
          COMPRESSOR_MAKE: 'Fabricante do compressor',
          COMPRESSOR_MODEL: 'Modelo do compressor',
          COMPRESSOR_TYPE: 'Tipo de compressor',
          NAMEPLATE_HP: 'Placa de identificação HP',
          NAMEPLATE_CAPACITY: 'Capacidade na placa (m³/h)',
          MOTOR_EFFICIENCY: 'Eficiência do motor (%)',
          MOTOR_VOLTAGE: 'Tensão do motor',
          FULL_LOAD_CURRENT: 'Corrente em plena carga (A)',
          FULL_LOAD_INPUT_POWER: 'Potência de entrada em plena carga (kW)',
          RATED_PRESSURE: 'Pressão nominal (kPag)',
          PRESSURE_SETPOINT: 'Ponto de ajuste de pressão (kPag)',
          CONTROL: 'Controle',
          TOTAL_AIR_STORAGE_SIZE: 'Capacidade total de armazenamento de ar (l)',
          IS_ACTIVE: 'Compressor Ativo / Desligado',
          OPERATION_TYPE: 'Intermediário / Base',
          PERCENT_LOAD: '% Carga',
          COMPRESSOR_SETPOINT_SEU: 'Ponto de ajuste do compressor (kPag)',
          COMPRESSOR_FLOW_SEU: 'Fluxo do compressor (m³/h)',
          SYSTEM_PRESSURE_SETPOINT: 'Ponto de ajuste da pressão do sistema (kPag)',
          SYSTEM_MEASURED_FLOW: 'Fluxo medido do sistema (m³/h)',
          DATE_TIME_RUNNING_STATE: 'Data e hora do estado de operação',
          NOTES: 'Notas',
          NAMEPLATE: 'Placa de identificação do compressor',
          DATASHEET: 'Ficha técnica do compressor',
          BHP: 'BHP',
          OPERATING_HOURS: 'Horas de operação',
          LOADED_PERCENT_TIME_RUNNING: '% Tempo em operação (carregado)',
          LOADED_PERCENT_FULL_LOAD_BHP: '% BHP em plena carga (Capacidade)',
          LOADED_MOTOR_EFFICIENCY: 'Eficiência do motor (%)',
          UNLOADED_PERCENT_TIME_RUNNING: '% Tempo em operação (sem carga)',
          UNLOADED_PERCENT_FULL_LOAD_BHP: '% BHP em plena carga (Capacidade) sem carga',
          UNLOADED_MOTOR_EFFICIENCY: 'Eficiência do motor (%)',
          ENERGY_COST: 'Taxa elétrica agregada ($)',
          ANNUAL_ENERGY_COST: 'Custo anual de energia ($)',
          ANNUAL_ENERGY_KWH: 'Consumo anual de energia (kWh)',
          COST_FULLY_LOADED: 'Custo quando totalmente carregado ($)',
          COST_UNLOADED: 'Custo quando em vazio ($)',
          KWH_PER_YEAR_LOADED: 'kWh por ano (carregado)',
          KWH_PER_YEAR_UNLOADED: 'kWh por ano (sem carga)',
          ENERGY_COST_PER_UNIT: '$/m³',
        },
        labelsImperial: {
          NAMEPLATE_CAPACITY: 'Capacidade na placa (cfm)',
          FULL_LOAD_INPUT_POWER: 'Potência de entrada em plena carga (BTU/h)',
          RATED_PRESSURE: 'Pressão nominal (psi)',
          PRESSURE_SETPOINT: 'Ponto de ajuste de pressão (psi)',
          TOTAL_AIR_STORAGE_SIZE: 'Capacidade total de armazenamento de ar (gal)',
          COMPRESSOR_SETPOINT_SEU: 'Ponto de ajuste do compressor (psi)',
          COMPRESSOR_FLOW_SEU: 'Fluxo do compressor (cfm)',
          SYSTEM_PRESSURE_SETPOINT: 'Ponto de ajuste da pressão do sistema (psi)',
          SYSTEM_MEASURED_FLOW: 'Fluxo medido do sistema (cfm)',
          ENERGY_COST_PER_UNIT: '$/cf',
        },
      },
      energyFields: {
        labels: {
          UTILITY_PROVIDER: 'Concessionária de energia',
          ENERGY_COST: '$/kWh',
          ENERGY_UNIT: 'Unidade',
          REBATE_COST: '$/kWh',
          REBATE_UNIT: 'Unidade',
          ENERGY_SOURCES: 'Fontes de energia',
          FE_HOURS_OPERATION: 'Horas de operação',
          FE_ENERGY_COST: 'Custo de energia ($/kWh)',
          FE_EFFICIENCY: 'Eficiência (kW/m³/h)',
          KWH_PER_FLOW: 'kWh/m³/h',
          COST_PER_FLOW: '$/m³',
        },
        labelsImperial: {
          FE_EFFICIENCY: 'Eficiência (kW/cfm)',
          KWH_PER_FLOW: 'kWh/cfm',
          COST_PER_FLOW: '$/cf',
        },
      },
    },
    hooks: {
      useError: {
        message: 'Erro de validação da solicitação. Por favor, verifique os campos do formulário',
      },
    },
    layouts: {
      dashboardLayout: {
        topBar: {
          registerADevice: 'Registrar um dispositivo',
          help: 'Ajuda',
          metric: 'Métrico',
          imperial: 'Imperial',
          downloadApk: 'Baixar APK',
          downloadOta: 'Baixar arquivo',
        },
        otaDialog: {
          title: 'Baixar arquivo',
          downloadButton: 'Baixar',
          serialNumberLabel: 'Número de série do dispositivo',
          serialNumberRequired: 'O número de série é obrigatório',
          fileDownloaded: 'Arquivo {{fileName}} baixado com sucesso',
          errorFetchingFile: 'Erro ao obter o arquivo. Por favor, tente novamente mais tarde',
          selectSerialNumber: 'Selecione um número de série do dispositivo',
        },
        banners: {
          leakRecordsList: {
            dialogOne: 'Você está no plano Essential.',
            dialogTwo: 'Clique ',
            dialogThree: 'aqui',
            dialogFour: 'para adquirir uma nova licença de Administrador ou entre em contato com ',
            dialogFive: 'support@prosaris.ca',
          },
          serviceUnavailable: 'Estamos enfrentando dificuldades técnicas. Nosso serviço pode estar afetado. Desculpe pelo inconveniente.',
          downForMaintenance: 'Estamos em manutenção no momento. Por favor, tente novamente mais tarde.',
          tagsManagement: {
            question: 'Está gostando das suas PROSARIS Smart Tags?',
            purchaseLink: 'Compre mais Smart Tags aqui!',
          },
        },
        mobileNav: {
          index: {
            menu: 'Menu',
            editProfile: 'Editar perfil',
            logout: 'Sair',
          },
        },
        notifications: {
          notificationsList: {
            clearAll: 'Limpar tudo',
            readAll: 'Marcar tudo como lido',
            noNotifications: 'Nenhuma notificação',
          },
        },
        index: {
          dashboard: 'Painel',
          records: 'Registros',
          actions: 'Ações',
          company: 'Empresa',
          tags: 'Tags',
        },
        loggedInAs: 'Conectado como',
      },
    },
    utils: {
      displayAssignedRecords: {
        cannontDeterminByField: 'Não é possível determinar o rótulo pelo campo {{field}}',
        cannontDeterminByLabel: 'Não é possível determinar o campo pelo rótulo {{label}}',
        active: 'Ativo',
        closed: 'Fechado',
      },
    },
    views: {
      commonUsedWords: {
        dashboard: 'Painel',
        records: 'Registros',
        actions: 'Ações',
        company: 'Empresa',
        tags: 'Tags',
        redirecting: 'Redirecionando você...',
      },
      account: {
        index: {
          updatePassword: 'Senha atualizada com sucesso.',
          accountDeletedSuccess: 'A conta {{user}} foi excluída com sucesso',
          accountDeletedError: 'Não é possível excluir a conta no momento. Por favor, tente novamente mais tarde.',
          authenticationError: 'Falha ao autenticar o usuário',
          personalDetails: 'Informações pessoais',
          currentPasswordIsRequired: 'A senha atual é obrigatória',
          username: 'Nome de usuário',
          changePassword: 'Alterar senha',
          currentPassword: 'Senha atual',
          profilePicture: 'Foto de perfil',
          dangerZone: 'Zona de risco',
          integrations: 'Integrações',
          sosShipments: 'Inventário SOS',
          sosSyncMessage:
            'Este processo aciona o processamento de pedidos SOS no Prosaris com os dados mais recentes do Inventário SOS. Embora este processo seja normalmente gerenciado automaticamente a cada 4 horas por meio de uma tarefa agendada, usar este botão permite que você inicie o processo manualmente.',
          sosSyncSuccess: 'A sincronização SOS foi acionada com sucesso',
          triggerSosSync: 'Acionar sincronização SOS',
          hubspot: 'HubSpot',
          hubspotSyncMessage:
            'Este processo envia instantaneamente os dados mais recentes da plataforma para o HubSpot. Essa sincronização ocorre automaticamente a cada hora por meio de uma tarefa agendada, mas clicar no botão permite que você acione a sincronização manualmente sempre que necessário.',
          hubspotSyncSuccess: 'A sincronização com o HubSpot foi acionada com sucesso',
          triggerHubspotSync: 'Acionar sincronização com HubSpot',
          deleteAccountTitle: 'Excluir conta',
          deleteAccountMessage: ' A conta não estará mais disponível e todas as informações pessoais serão permanentemente excluídas.',
          alertTitle: 'Por favor, confirme a exclusão da conta',
          deleteDialog: {
            dialogTwo: 'Excluir sua conta removerá permanentemente todas as suas informações pessoais do nosso banco de dados.',
            dialogThree: 'ESTA AÇÃO NÃO PODE SER DESFEITA.',
            dialogFour: 'Por favor, insira sua senha para continuar.',
          },
        },
        toolBar: {
          cacheClearedSuccess: 'Cache limpo com sucesso!',
          editProfile: 'Editar perfil',
          clearCache: 'Limpar cache',
          alertTitle: 'Por favor, confirme a limpeza do cache do aplicativo',
          deleteAll: 'Excluir tudo',
          accordionDialog: {
            dialogOne: 'Isso excluirá todas as configurações armazenadas para as seguintes páginas:',
            dialogTwo: 'Gráficos, Filtros de gráficos, Período',
            dialogThree: 'Filtros, Ordenação, Colunas, Pré-visualização',
            dialogFour: 'Filtros, Colunas',
            dialogFive: 'Empresa selecionada',
            dialogSix: 'Filtros, Colunas',
          },
          deleteSelective: 'Excluir seletivamente',
          selectiveDialog: 'Por favor, selecione as configurações armazenadas que deseja excluir:',
        },
        constants: {
          Dashboard: {
            TIMEFRAME: 'Período',
            CHART_FILTERS: 'Filtros de gráfico',
            CHARTS: 'Gráficos',
          },
          Records: {
            HIGHLIGHTED: 'Pré-visualização',
            COLUMNS: 'Colunas',
            FILTERS: 'Filtros',
            SORT_COLUMN: 'Ordenação',
          },
          Actions: {
            FILTERS: 'Filtros',
            COLUMNS: 'Colunas',
          },
          Company: {
            SELECTED: 'Empresa selecionada',
          },
          Tags: {
            FILTERS: 'Filtros',
            COLUMNS: 'Colunas',
          },
        },
      },
      assignmentsList: {
        filters: {
          companyName: 'Empresa',
          'leakStatus.building': 'Unidade/Equipamento',
          'leakStatus.facility': 'Instalação',
          'leakStatus.smartTag': 'Tags inteligentes nº',
          'leakStatus.workRef': 'Ref. de trabalho nº',
        },
        tableBody: {
          noAssignmentsToDisplay: 'Não há atribuições para exibir',
        },
        filtersCommonWords: {
          recordsFilter: 'Filtro de registros',
          column: 'Coluna',
          selectAColumn: 'Selecione uma coluna...',
          addSearchTerm: 'Adicionar um termo de busca...',
          filtersArentAvailable: 'Filtros não estão disponíveis',
          value: 'Valor',
          exportCSV: 'Exportar CSV',
          show: 'Mostrar',
          loadMoreRecords: 'Carregar mais registros',
          selectedAllRecords: 'Todos os registros selecionados ({{totalNum}})',
          selectedFromRecords: '{{selectedNum}} de {{totalNum}} registros selecionados',
          reset: 'Redefinir',
        },
        invalidColumn: 'Coluna inválida {{column}}',
        assignedActionRecords: 'Registros de ações atribuídas',
      },
      auth: {
        forgotPasswordView: {
          forgotYourPassword: 'Esqueceu sua senha?',
          successMessage: 'Enviamos um e-mail de confirmação para',
        },
        authSuccess: {
          thanks: 'Obrigado!',
          backToLogin: 'Entrar na plataforma',
        },
        loginView: {
          forgotPass: 'Esqueceu a senha?',
          createAccount: 'Criar uma conta',
          passwordIsRequired: 'A senha é obrigatória',
          resetPassword: 'Redefinir senha',
          contactSupport: 'Por favor, entre em contato com support@prosaris.ca',
          incorrectEmailOrPassword: 'E-mail ou senha incorretos',
          resetPassDialog: {
            dialogOne: 'Você precisa redefinir sua senha antes de continuar.',
            dialogTwo: 'Um e-mail de redefinição de senha foi enviado para você com as instruções.',
          },
          ok: 'OK',
        },
        resetPasswordView: {
          passwordSuccessFullyReset: 'A senha foi redefinida com sucesso',
          enterNewPassword: 'Digite sua nova senha abaixo.',
          passwordChanged: 'Sua senha foi alterada.',
        },
        createCompanyView: {
          companyName: 'Nome da empresa',
          companyNameIsRequired: 'O nome da empresa é obrigatório',
          serialNumberIsRequired: 'O número de série do dispositivo é obrigatório',
          successTitle: 'Parabéns! Sua conta da {{companyName}} foi criada com sucesso.',
          successDescription:
            'Sua conta da empresa foi criada. Você pode adicionar outros membros da equipe à empresa na plataforma. Para dúvidas adicionais, entre em contato com {{companyEmail}}',
          companySetup: 'Configuração da empresa',
          createCompany: 'Criar nova empresa',
          createCompanyDescription:
            'Se sua organização é nova na plataforma {{companyName}}, agora você pode criar sua empresa na plataforma. Você será o administrador da empresa.',
          deviceSerialNumber: 'Número de série do dispositivo',
          or: 'OU',
          joinExistingCompany: 'Ingressar em empresa existente',
          joinExistingCompanyDescription:
            'Se sua organização já possui uma conta de empresa registrada na plataforma {{companyName}} e você deseja ingressar nessa conta, siga uma das duas opções abaixo.',

          joinExistingCompanyOptions: {
            optionOne: 'Entre em contato conosco em {{supportEmail}}. Um membro da equipe adicionará você à empresa desejada.',
            optionTwo:
              'Entre em contato com o administrador da empresa. Ele pode enviar um convite diretamente pela plataforma para adicioná-lo lá.',
          },
          essentialRoleMessage:
            'Sua conta se enquadra automaticamente no nível gratuito Essential. Para saber mais sobre os diferentes níveis da plataforma {{companyName}}, entre em contato com {{supportEmail}}',
          userRoleMessage: 'Além disso, você ingressou na {{companyName}} como Usuário na plataforma. Faça login para acessar sua empresa.',
        },
        amazonRegistration: {
          selectYourCompany: 'Selecione sua empresa',
          selectCompanyDescription: 'Selecione a empresa que você deseja ingressar.',
          searchCompanies: 'Buscar empresas...',
          finishRegistration: 'Concluir',
          cantFindCompany: 'Não encontra sua empresa?',
          cantFindCompanyDescription:
            'Se sua organização já possui uma conta de empresa registrada e você deseja ingressar nela, siga uma das opções abaixo.',
          cantFindCompanyOptionOne:
            'Entre em contato com <a href="mailto:{{supportEmail}}"><strong>{{supportEmail}}</strong></a> e informe o nome da empresa que está tentando ingressar.',
          companyRequired: 'Selecione uma empresa para continuar',
          registrationSuccess: 'Conta criada com sucesso! Faça login.',
          registrationError: 'Falha ao criar a conta. Tente novamente.',
          back: 'Voltar',
        },
      },
      calculateLeak: {
        index: {
          loadingLeakError: 'Ocorreu um erro inesperado ao carregar os dados de vazamento',
          calculatingError: 'Ocorreu um erro inesperado durante o cálculo',
          dbMeasured: 'dB Medido',
          calculate: 'Calcular',
          calculating: 'Calculando...',
          outflowCoefficient: 'Coeficiente de escoamento',
          kwhPerYear: 'kWh/ano',
        },
      },
      companies: {
        commonUsedWords: {
          assignedAdminLicenses: 'Licenças de administrador atribuídas',
          company: 'Empresa',
          totalAccounts: 'Total de contas',
          email: 'E-mail',
          name: 'Nome',
          loadCompanyUsersError: 'Falha ao carregar os usuários da empresa. Por favor, tente novamente mais tarde',
          activated: 'Ativado',
          deactivated: 'Desativado',
          activating: 'Ativando',
          deactivating: 'Desativando',
          deactivate: 'Desativar',
          activate: 'Ativar',
          set: 'Definir',
          youAreGoingTo: 'Você está prestes a',
          areYouSure: 'Você tem certeza?',
          companyNameIsRequired: 'O nome da empresa é obrigatório',
          editCompany: 'Editar empresa',
          moveCompany: 'Mover empresa',
          createCompany: 'Criar empresa',
          viewHistory: 'Ver histórico',
          exportCSV: 'Exportar CSV',
          onEssentialPlan: 'Você está em um plano Essential. Por favor, entre em contato com support@prosaris.ca',
        },
        groupPerformance: {
          title: 'Desempenho do grupo',
          normalizeData: 'Normalizar dados',
          selectTimeline: 'Selecionar período',
          selectCriteria: 'Selecionar critério',
        },
        hubspotTickets: {
          title: 'Progresso de Integração',
          searchPlaceholder: 'Pesquisar tickets por instalação...',
          syncNow: 'Sincronizar Agora',
          syncing: 'Sincronizando...',
          syncTooltip: 'Isto irá buscar as etapas de pipeline e tickets mais recentes do HubSpot',
          unmappedCompanies: 'Empresas não mapeadas',
          notStartedOnboarding: 'Integração não iniciada',
          instructions: 'Estes são os tickets do HubSpot que não têm instalações correspondentes na plataforma PROSARIS. Para criar um mapeamento, siga as etapas abaixo:',
          step1: 'Criar uma nova instalação na plataforma PROSARIS',
          step2Before: 'Clique no',
          step2After: 'botão',
          noUnmappedTickets: 'Nenhum ticket não mapeado',
          noCompaniesWithoutOnboarding: 'Nenhuma empresa sem integração',
          noTicketsInStage: 'Nenhum ticket nesta etapa',
          loadingPipelines: 'Carregando pipelines...',
          loadingTickets: 'Carregando tickets...',
          loadingCompanies: 'Carregando empresas...',
          errorLoadingPipelines: 'Erro ao carregar pipelines',
          noPipelinesAvailable: 'Nenhum pipeline disponível',
          noStagesAvailable: 'Nenhuma etapa disponível',
          lastUpdated: 'Última atualização: ',
          syncSuccess: 'Dados do HubSpot sincronizados com sucesso',
          syncPipelineFailed: 'Falha ao sincronizar pipeline do HubSpot',
          syncTicketsFailed: 'Falha ao sincronizar tickets do HubSpot',
        },
        charts: {
          chart: {
            criteria: {
              KWH: 'Total kWh/ano',
              LOSS: 'Perda total ($/ano)',
              FLOW: 'Fluxo mássico total',
            },
            noDataAvailable: 'Nenhum dado disponível',
            topNCompanies: 'Top {{numCompanies}} empresas',
          },
        },
        accounts: {
          inviteUsers: {
            title: 'Convidar usuários para {{companyName}}',
            emailAddresses: 'Endereços de e-mail dos usuários',
            emailsRequired: 'Os e-mails são obrigatórios',
            successMessage: 'Usuários foram convidados com sucesso',
            note: 'Digite os endereços de e-mail em uma nova linha ou separados por vírgula.',
            tooltip: 'Cada usuário receberá um convite para ingressar na empresa.',
            invite: 'Convidar',
          },
          accountDialog: {
            companyIsRequired: 'A empresa é obrigatória',
            roleIsRequired: 'A função é obrigatória',
            createAccountSuccessMessage: 'Conta criada com sucesso',
            emailTakenErrorMessage: 'Já existe uma conta com este e-mail no sistema',
            errorWhileCreatingAccountMessage: 'Erro ao criar a conta. Por favor, tente novamente mais tarde.',
            changeAccountSuccessMessage: 'Conta atualizada com sucesso',
            errorWhileChangingAccountMessage: 'Erro ao atualizar a conta. Por favor, tente novamente.',
            editAccount: 'Editar conta',
            createAccount: 'Criar conta',
            role: 'Função',
          },
          changeOwner: {
            changeOwnerMessage: 'Você também deseja alterar o responsável pelos registros de vazamento relacionados a esta conta?',
            no: 'Não, manter a conta atual',
          },
          contentCell: {
            loadAccountRolesError: 'Falha ao carregar as informações de funções da conta. Por favor, tente novamente mais tarde.',
            changeRoleSuccessMessage: 'A conta {{email}} recebeu uma nova função',
            changeRoleErrorMessage: 'Erro ao atualizar a função da conta {{email}}. Por favor, tente novamente mais tarde.',
            editUser: 'Editar usuário',
            adminSetPassword: 'Administrador definiu a senha',
            adminSetSubRenewalDate: 'Administrador definiu a data de renovação da assinatura',
            resetPassword: 'Redefinir senha',
            user: 'Usuário',
            deleteUser: 'Excluir usuário',
          },
          index: {
            noUsersToDisplay: 'Não há usuários para exibir',
            changeStatusSuccessMessage: 'Usuário {{isActive}} com sucesso',
            changeStatusErrorMessage: 'Erro ao {{isActive}} o usuário. Por favor, tente novamente',
            changeOwnerSuccessMessage: 'Os registros foram transferidos para um novo responsável',
            changeOwnerErrorMessage:
              'Não é possível transferir os registros para um novo responsável. Por favor, tente novamente mais tarde',
            deleteAccountMutationSuccessMessage: 'A conta {{email}} foi excluída com sucesso',
            deleteAccountMutationErrorMessage: 'Não é possível excluir a conta {{email}} no momento. Por favor, tente novamente mais tarde',
            resetAccountPassWordSuccessMessage: 'E-mail de redefinição de senha enviado com sucesso.',
            users: 'usuários',
            noneAvailable: 'Nenhum disponível',
            of: 'de',
            contactSupport:
              'Por favor, entre em contato com support@prosaris.ca para mais informações sobre licenças de administrador da empresa',
            findAccount: 'Encontrar conta',
            placeholder: 'Digite o nome ou e-mail...',
            tooltip: 'Você precisa de pelo menos uma licença de administrador da empresa antes de poder convidar usuários',
            invite: 'Convidar',
            alertDialog: {
              messageOne: 'Por favor, confirme a solicitação de redefinição de senha do usuário',
              messageTwo: 'Por favor, confirme a alteração de status da conta',
              messageThree: 'Por favor, confirme a exclusão da conta',
            },
            sendAPasswordResetEmail: 'Você está prestes a enviar um e-mail de redefinição de senha para a seguinte conta:',
            confirmMessage: 'Você deseja continuar?',
            followingAccount: 'conta a seguir:',
            delete: 'EXCLUIR',
            userCreatedDialogTitle: 'Link de redefinição de senha enviado com sucesso',
            userCreatedDialogDescription:
              'O usuário recebeu um link de redefinição de senha em seu endereço de e-mail. Você também pode copiar o link abaixo.',
          },
          adminSetPassword: {
            changedUserPasswordSuccessMessage: 'Senha da conta atualizada com sucesso',
            changedUserPasswordErrorMessage: 'Erro ao atualizar a conta. Por favor, tente novamente.',
            setNewPassword: 'Definir nova senha',
            accountPasswordUpdated: 'Senha da conta atualizada',
            accountPasswordUpdatedDescription:
              'A senha da conta foi atualizada com sucesso. Você pode clicar no botão abaixo para copiar a nova senha.',
          },
          adminSetSubRenewalDate: {
            title: 'Definir data de renovação da assinatura',
            subRenewalDate: 'Data de renovação da assinatura',
            changedSubRenewalDateSuccessMessage: 'Data de renovação da assinatura atualizada com sucesso',
            changedSubRenewalDateErrorMessage: 'Erro ao atualizar a conta. Por favor, tente novamente.',
          },
          setPassword: {
            automatic: 'Gerar automaticamente uma senha forte',
            manual: 'Criar senha manualmente',
            copyLinkInstruction: 'Você poderá visualizar e copiar a senha na próxima etapa',
          },
          userCreatedDialog: {
            title: 'Usuário criado com sucesso',
            description:
              'Seu novo usuário já pode começar a usar a plataforma. O usuário também receberá um link por e-mail para redefinir a senha.',
            passwordCopied: 'Senha copiada para a área de transferência',
            passwordResetLinkCopied: 'Link de redefinição de senha copiado para a área de transferência',
            copyPassword: 'Copiar senha',
            copyPasswordResetLink: 'Copiar link de redefinição de senha',
          },
          useRoleOptions: {
            notAvailable: '(não disponível)',
            adminSeatTaken: '(vaga de administrador ocupada)',
            allSeatsAreTaken: '(todas as {{numSeats}} vagas estão ocupadas)',
            adminRolesTitle: 'Funções de administrador',
            roles: {
              superAdmin: 'Administrador raiz',
              companyAdmin: 'Empresa (Admin)',
              superCompanyAdmin: 'Corporativo (Admin)',
              companyRead: 'Empresa (Leitura)',
              superAdminRead: 'Administrador raiz (Leitura)',
              integrator: 'Integrador',
              auditor: 'Auditor',
              user: 'Usuário',
              essential: 'Prosaris Essential',
              enterpriseAdmin: 'Administrador corporativo',
            },
            rolesDescriptions: {
              superAdmin: 'Permissão para ter controle total sobre várias empresas.',
              companyAdmin: 'Permissão para visualizar, editar e atribuir registros da empresa.',
              superCompanyAdmin: 'Permissão para ter controle total sobre registros e usuários da empresa.',
              companyRead: 'Permissão para visualizar registros da empresa em modo somente leitura.',
              superAdminRead: 'Permissão para ter acesso somente leitura a todas as empresas.',
              integrator: 'Permite que integrações de terceiros gerenciem empresas e contas.',
              auditor: 'Permite a auditoria de registros de vazamentos.',
              user: 'Permissão para criar/atualizar/excluir seus próprios registros.',
              essential: 'Um papel com funcionalidade limitada.',
              enterpriseAdmin: 'Permissão para ter controle total da corporação.',
            },
            nonAdminRolesTitle: 'Funções não administrativas',
          },
        },
        audits: {
          index: {
            loadAuditsErrorMessage: 'Falha ao carregar as auditorias. Por favor, tente novamente mais tarde',
            audits: 'auditorias',
            noAuditsToDisplay: 'Não há auditorias para exibir',
            findByAuditorEmail: 'Encontrar por e-mail do auditor',
            placeholder: 'Digite o e-mail do auditor...',
          },
        },
        companyTabs: {
          facility: {
            index: {
              facilityNameIsRequired: 'O nome da instalação é obrigatório',
              hoursYearlyIsRequired: 'O total de horas/ano é obrigatório',
              totalHoursYearly: 'O total de horas/ano não pode exceder 8760',
              invalidPhoneNumber: 'Número de telefone inválido',
              createErrorMessage: 'Horas x turnos não pode exceder 24h',
              loadFacilityErrorMessage: 'Falha ao carregar a instalação. Por favor, tente novamente mais tarde',
              createFacilitySuccessMessage: 'Instalação criada com sucesso',
              createFacilityErrorMessage: 'Erro ao criar a instalação. Por favor, tente novamente.',
              changeFacilitySuccessMessage: 'Instalação atualizada com sucesso',
              changeFacilityErrorMessage: 'Erro ao atualizar a instalação. Por favor, tente novamente.',
              facilityName: 'Nome da instalação',
              abbreviation: 'Abreviação',
              address: 'Endereço',
              enterALocation: 'Insira um local',
              tooltip: 'para atividades de Gestão de Energia, também Aprovador de Relatórios',
              energyMgtOwner: 'Responsável pela Gestão de Energia',
              title: 'Título',
              phone: 'Telefone',
              tooltipTwo: 'para renovações de soluções e problemas gerais da conta',
              accountOwner: 'Responsável pela conta',
              manufacturingArea: 'Área de manufatura',
              size: 'Tamanho',
              unit: 'Unidade',
              hoursOfOperation: 'Horas de operação',
              auditFrequency: 'Frequência de auditoria',
            },
            operationHours: {
              daysPerWeek: 'Dias/semana',
              shiftsPerDay: 'Turnos/dia',
              hoursPerShift: 'Horas/turno',
              weeksPerYear: '52 semanas/ano',
              totalHoursYearly: 'Total = Horas/ano',
            },
            constants: {
              constant: 'Constante',
              monthly: 'Mensal',
              threeMonth: '3 meses',
              fourMonth: '4 meses',
              sixMonth: '6 meses',
              nineMonth: '9 meses',
              annual: 'Anual',
              sqft: 'Pés quadrados [SQFT]',
              sqm: 'Metros quadrados [SQM]',
            },
          },
          index: {
            users: 'Usuários',
            devices: 'Dispositivos',
            facility: 'Instalação',
            energy: 'Energia',
            seu: 'USEs - Comp.',
            enpi: 'EnPIs/EnBs',
            routes: 'Rotas',
            audit: 'Auditorias',
            comingSoon: 'Em breve...',
          },
        },
        enpis: {
          index: {
            loadEnpisErrorMessage: 'Falha ao carregar os EnPIs. Por favor, tente novamente mais tarde',
            createEnpisSuccessMessage: 'EnPIs criados com sucesso',
            createEnpisErrorMessage: 'Erro ao criar os EnPIs. Por favor, tente novamente.',
            changeEnpisSuccessMessage: 'EnPIs atualizados com sucesso',
            changeEnpisErrorMessage: 'Erro ao atualizar os EnPIs. Por favor, tente novamente.',
            showHistory: 'Mostrar histórico',
          },
        },
        changeHistory: {
          bulkOperation: 'como uma operação em massa',
          details: 'detalhes',
          created: 'criado',
          updated: 'atualizado',
          componentTypes: {
            enpis: 'EnPIs',
            company: 'Empresa',
          },
          history: 'Histórico',
          noHistory: 'Sem histórico',
        },
        energy: {
          index: {
            utilProvider: 'Concessionária de energia',
            energyUse: 'Uso de energia e tipo de consumo',

            error: {
              loadFacility: 'Falha ao carregar a instalação. Por favor, tente novamente mais tarde',
              loadEnergy: 'Falha ao carregar os dados de energia. Por favor, tente novamente mais tarde',
              loadUtilProviderLogo: 'Falha ao carregar o logotipo da concessionária de energia. Por favor, tente novamente mais tarde',
              createEnergy: 'Falha ao criar os dados de energia. Por favor, tente novamente mais tarde',
              createUtilProviderLogo: 'Falha ao enviar o logotipo da concessionária de energia. Por favor, tente novamente mais tarde',
              updateEnergy: 'Falha ao atualizar os dados de energia. Por favor, tente novamente mais tarde',
              deleteUtilProviderLogo: 'Falha ao excluir o logotipo da concessionária de energia. Por favor, tente novamente mais tarde',
            },
            success: {
              createEnergy: 'Dados de energia criados com sucesso',
              updateEnergy: 'Dados de energia atualizados com sucesso',
            },
          },
          utilProvider: {
            index: {
              costOfEnergy: 'Custo de energia',
              incentiveRate: 'Taxa de incentivo',
              energySources: 'Fontes de energia',
              per: 'por',
              validations: {
                utilProviderIsRequired: 'A concessionária de energia é obrigatória',
                costOfEnergyIsRequired: 'O custo de energia é obrigatório',
                costOfEnergyMustBeNumber: 'O custo de energia deve ser um número',
                costOfEnergyMustBeGreaterThanZero: 'O custo de energia deve ser maior que 0',
                costOfRebateMustBeAtLeatZero: 'O custo do reembolso deve ser no mínimo 0',
                costOfRebateMustBeNumber: 'O custo do reembolso deve ser um número',
              },
            },
            UtilProviderLogo: {
              error: {
                fileSize: 'O tamanho do arquivo deve ser menor que 1 MB',
                preview: 'Falha ao pré-visualizar a imagem',
              },
              logo: 'Logo',
              addLogo: 'Adicionar logo',
              removeLogo: 'Remover logo',
            },
            EnergySources: {
              energySource: 'Fonte de energia',
              percentage: 'Percentual',
              selectEnergySource: 'Selecionar fonte de energia',
              addEnergySource: 'Adicionar fonte de energia',
              totalPercentage: 'Percentual total',
              mustBeEqualTo100: '(deve ser igual a 100%)',
              constants: {
                energySources: {
                  NATURAL_GAS: 'Gás natural',
                  FUEL_OIL: 'Óleo combustível',
                  DIESEL: 'Diesel',
                  GASOLINE: 'Gasolina',
                  PROPANE: 'Propano',
                  COAL: 'Carvão',
                  WIND: 'Eólica',
                  GEOTHERMAL: 'Geotérmica',
                  BIOMASS: 'Biomassa',
                  STEAM: 'Vapor',
                  COMPRESSED_AIR: 'Ar comprimido',
                  CHILLED_WATER: 'Água gelada',
                  NUCLEAR: 'Nuclear',
                  HYDRO: 'Hidrelétrica',
                  SOLAR: 'Solar',
                },
              },
            },
          },
          energyUse: {
            index: {
              currentCalcApproach: 'Método de cálculo atual',
              currentCalcApproachMessage:
                "Este método de cálculo é aplicado por padrão a todos os campos de 'Custo de energia', a menos que o usuário o substitua.",
              alertTitle: 'Redefinir método de cálculo',
              alertMessageOne:
                "Esta ação interromperá o uso do método de cálculo atual para todos os campos de 'Custo de energia' daqui em diante.",
              alertMessageTwo: 'Observe que essa alteração não afetará os registros existentes.',
              alertMessageThree: 'Tem certeza de que deseja prosseguir com a redefinição?',
            },
            ReportType: {
              calcApproach: 'Método de cálculo',
              constants: {
                calculations: {
                  FIXED: 'Eficiência fixa',
                  USDOE: 'US DoE',
                  NREL: 'NREL Capítulo 22',
                },
              },
              setAsCurrent: 'Definir como atual',
              setAsCurrentMessage: "Este método de cálculo será usado para todos os campos de 'Custo de energia' daqui em diante.",
            },
            calculations: {
              FixedEfficiency: {
                validations: {
                  efficiencyMustBeGreaterThanZero: 'A eficiência deve ser maior ou igual a 0',
                  efficiencyMustBeNumber: 'A eficiência deve ser um número',
                  operationHoursMustBeGreaterThanZero: 'As horas de operação devem ser maiores ou iguais a 0',
                  operationHoursMustBeLessThan8760: 'As horas de operação devem ser menores que 8760',
                  operationHoursMustBeNumber: 'As horas de operação devem ser um número',
                },
              },
              UsDoe: {
                loaded: 'Carregado',
                unloaded: 'Sem carga',
                calcSummary: 'Resumo do cálculo',
                currentOperatingSystems: 'Sistemas operacionais atuais',
                noCompsFoundAddCompOne: 'Nenhum compressor encontrado. Adicione um compressor na',
                noCompsFoundAddCompTwo: 'aba acima.',
              },
            },
          },
        },
        compressors: {
          compressorDialog: {
            plateError: 'Erro ao enviar a placa de identificação. Por favor, tente novamente mais tarde.',
            dataSheetError: 'Erro ao enviar a ficha técnica. Por favor, tente novamente mais tarde.',
            createSuccess: 'Compressor {{tag}} criado',
            createError: 'Falha ao criar compressor. Por favor, tente novamente mais tarde.',
            createCompressor: 'Adicionar compressor',
            selectTemplate: 'Escolha um compressor...',
            templatesError: 'Falha ao carregar pesquisas de compressores. Tente novamente mais tarde.',
            searchPlaceholder: 'Pesquisar por modelo ou fabricante... (ex.: G11-100, Atlas Copco)',
            templateDescription:
              'Um compressor do tipo Parafuso Rotativo pode ser adicionado escolhendo da lista de compressores disponíveis ou preenchendo as informações manualmente. Se você selecionar um compressor da lista, o restante das informações será preenchido automaticamente. Você sempre poderá ajustar as informações depois. Os compressores dos tipos Alternativo e Centrífugo precisarão ser inseridos manualmente.',
            quickSelect: 'Seleção rápida',
            quickSelectDescription: 'Escolha a partir de pesquisas de compressores existentes',
            basicInfo: 'Informações básicas',
            basicInfoDescription: 'Detalhes gerais de identificação do compressor',
            technicalSpecifications: 'Especificações técnicas',
            technicalSpecificationsDescription: 'Parâmetros de desempenho e operação',
            documentation: 'Documentação',
            documentationDescription: 'Carregar arquivos e documentação do compressor',
            compressorSpecifications: 'Especificações do compressor',
            nameplate: 'Placa de identificação',
            motor: 'Motor',
            fullLoad: 'Carga total',
            pressure: 'Pressão',
            other: 'Outro',
            compressorFiles: 'Arquivos do compressor',
            datasheetDisplayError: 'Falha ao exibir o arquivo da ficha técnica',
            datasheetProcessError: 'Falha ao processar o arquivo da ficha técnica',
          },
          compressorFile: {
            tip: 'Adicionar arquivo',
            removeFile: 'Remover arquivo',
            removeImage: 'Remover imagem',
            title: 'Por favor, confirme a exclusão do compressor {{prop}}',
            proceed: 'Você deseja continuar?',
          },
          compressorForm: {
            compTagIsReq: 'A etiqueta do compressor é obrigatória',
            controlIsReq: 'O controle é obrigatório',
            hpMustBeNum: 'A potência nominal (HP) deve ser um número',
            capMustBeNum: 'A capacidade nominal deve ser um número',
            motorEffMustBeNum: 'A eficiência do motor deve ser um número',
            motorVoltMustBeNum: 'A tensão do motor deve ser um número',
            loadMustBeNum: 'A corrente em plena carga deve ser um número',
            loadInputMustBeNum: 'A potência de entrada em plena carga deve ser um número',
            pressureMustBeNum: 'A pressão nominal deve ser um número',
            setpointMustBeNum: 'O ponto de ajuste de pressão deve ser um número',
            airMustBeNum: 'A capacidade total de armazenamento de ar deve ser um número',
            addImage: 'Adicionar imagem',
            addFile: 'Adicionar arquivo',
          },
          constants: {
            compressorTypes: {
              ROTARY_SCREW: 'Parafuso rotativo',
              RECIPROCATING: 'Alternativo',
              CENTRIFUGAL: 'Centrífugo',
            },
            rotaryScrew: {
              loadUnloadOilFree: 'Carga/Descarga – Isento de óleo',
              loadUnload1Gal: 'Carga/Descarga (1 gal/CFM)',
              loadUnload3Gal: 'Carga/Descarga (3 gal/CFM)',
              loadUnload5Gal: 'Carga/Descarga (5 gal/CFM)',
              loadUnload10Gal: 'Carga/Descarga (10 gal/CFM)',
              ivmWithBlowdown: 'Modulação da válvula de admissão (sem alívio)',
              ivmWithoutBlowdown: 'Modulação da válvula de admissão (com alívio)',
              variableDisplacement: 'Deslocamento variável',
              vsdWithUnloading: 'VSD com descarga',
              vsdWithStopping: 'VSD com parada',
            },
            reciprocating: {
              reciprocatingOnOffControl: 'Controle liga/desliga',
              reciprocatingLoadUnload: 'Carga/Descarga',
            },
            centrifugal: {
              centrifugalInletIgv: 'IBV com alívio',
              centrifugalInletIbv: 'IGV com alívio',
            },
          },
          contentCell: {
            min: '% deve ser no mínimo 0',
            max: '% não pode ser maior que 100',
            max150: '% não pode ser maior que 150',
            typeError: 'A carga deve ser um percentual válido',
            setpointMustBeNum: 'O ponto de ajuste do compressor deve ser um número',
            flowMustBeNum: 'O fluxo do compressor deve ser um número',
            pressureSetpointMustBeNum: 'O ponto de ajuste da pressão do sistema deve ser um número',
            measuredFlowMustBeNum: 'O fluxo medido do sistema deve ser um número',
            dateTime: 'Selecione a data e a hora',
            active: 'ATIVO',
            off: 'DESLIGADO',
            trim: 'ajuste',
            baseLoad: 'carga base',
          },
          index: {
            error: 'Falha ao carregar os compressores. Por favor, tente novamente mais tarde',
            nameplateError: 'Falha ao carregar a placa de identificação. Por favor, tente novamente mais tarde',
            dataSheetError: 'Falha ao carregar a ficha técnica. Por favor, tente novamente mais tarde',
            changeCompSuccess: 'Compressor atualizado com sucesso',
            changeCompError: 'Erro ao atualizar o compressor. Por favor, tente novamente.',
            deleteCompSuccess: 'Compressor excluído com sucesso',
            deleteCompError: 'Erro ao excluir o compressor. Por favor, tente novamente.',
            createCompNameplateSuccess: 'Placa de identificação do compressor enviada com sucesso',
            createCompNameplateError: 'Erro ao enviar a placa de identificação. Por favor, tente novamente mais tarde.',
            deleteCompNameplateSuccess: 'Placa de identificação do compressor excluída com sucesso',
            deleteCompNameplateError: 'Erro ao excluir a placa de identificação do compressor. Por favor, tente novamente mais tarde.',
            createCompDataSheetSuccess: 'Ficha técnica do compressor enviada com sucesso',
            createCompDataSheetError: 'Erro ao enviar a ficha técnica. Por favor, tente novamente mais tarde.',
            deleteCompDataSheetSuccess: 'Ficha técnica do compressor excluída com sucesso',
            deleteCompDataSheetError: 'Erro ao excluir a ficha técnica. Por favor, tente novamente mais tarde.',
            changeCompanyCompSuccess: 'Dados do sistema atualizados com sucesso',
            changeCompanyCompError: 'Erro ao atualizar os dados do sistema. Por favor, tente novamente.',
            compDesignData: 'Dados de projeto do compressor',
            comp: 'Compressores:',
            addComp: 'Adicionar compressor',
            editCompPermission: 'Você precisa de uma licença de administrador para editar o compressor. Por favor, entre em contato com',
            selectOption: 'Selecione uma opção',
            undoChanges: 'Desfazer alterações',
            selectComp: 'Selecione um compressor acima.',
            noCompsFound: 'Nenhum compressor encontrado.',
            compRunningState: 'Estado de operação do compressor',
            noCompsFoundAddComp: 'Nenhum compressor encontrado. Adicione um compressor na seção acima.',
            title: 'Por favor, confirme a exclusão do compressor',
            areYouSure: 'Tem certeza de que deseja',
            compressor: 'compressor',
            delete: 'excluir',
          },
        },
        devices: {
          contentCell: {
            device: 'Dispositivo',
            usedByMultipleCompanies: 'é usado por várias empresas',
          },
          index: {
            noDevicesToDisplay: 'Nenhum dispositivo registrou dados para esta empresa',
            loadingDevicesErrorMessage: 'Falha ao carregar os dispositivos da empresa. Por favor, tente novamente mais tarde',
            changeStatusSuccessMessage: 'Dispositivo {{isActive}} com sucesso',
            changeStatusErrorMessage: 'Erro ao {{isActive}} o dispositivo. Por favor, tente novamente',
            devices: 'dispositivos',
            findDevice: 'Encontrar dispositivo',
            placeholder: 'Digite o ID do dispositivo...',
            activatedOn: 'Ativado em',
            title: 'Por favor, confirme a alteração de status do dispositivo',
          },
        },
        company: {
          deleteCompanySuccessMessage: '{{companyName}} foi excluída com sucesso',
          deleteCompanyErrorMessage: 'Falha ao excluir {{companyName}}. Por favor, tente novamente mais tarde.',
          needAdminLicense:
            'Você precisa de uma licença de administrador para acessar este recurso. Por favor, entre em contato com support@prosaris.ca',
          deleteChildCompanyFirst:
            'Não é possível excluir uma empresa que possua empresas filhas ou contas. Por favor, exclua todas as empresas filhas e contas primeiro.',
          editSettings: 'Editar configurações',
          createASubCompany: 'Criar uma subsidiária para {{companyName}}',
          deleteCompany: 'Excluir empresa',
          cannotCreateChildCompanyDialog: {
            messageOne:
              'Você atingiu o número máximo de empresas que podem ser criadas pela(s) sua(s) conta(s) corporativa(s). Por favor, entre em contato com ',
            messageTwo: 'para mais detalhes.',
          },
          deleteCompanyDialog: {
            title: 'Por favor, confirme a exclusão da empresa',
            delete: 'Excluir',
            deleting: 'Excluindo',
            permanentlyDeleted: 'a removerá permanentemente do nosso banco de dados.',
            cannotBeUndone: 'ESSA AÇÃO NÃO PODE SER DESFEITA.',
          },
        },
        companyDialog: {
          industryIsRequired: 'O setor é obrigatório',
          createLogoErroerMessage: 'Erro ao enviar a imagem. Por favor, tente novamente mais tarde.',
          deleteLogoErrorMessage: 'Erro ao excluir a imagem. Por favor, tente novamente mais tarde.',
          createCompanySuccessMessage: 'Empresa {{name}} criada',
          createCompanyErrorMessage: 'Falha ao criar a empresa. Por favor, tente novamente mais tarde.',
          changeCompanySuccessMessage: 'Empresa {{name}} atualizada',
          changeCompanyErrorMessage: 'Falha ao alterar o parâmetro da empresa. Por favor, tente novamente mais tarde.',
          language: 'Idioma',
          industry: 'Setor',
          country: 'País',
          currency: 'Moeda',
        },
        companyLogo: {
          setImageErrorMessage: 'O tamanho do arquivo deve ser menor que 1 MB',
          logo: 'Logo',
          add: 'Adicionar',
          removeLogo: 'Remover logo',
          addLogo: 'Adicionar logo',
        },
        index: {
          loadCompaniesErrorMessage: 'Falha ao carregar a lista de empresas. Por favor, tente novamente mais tarde',
          loadAccountsErrorMessage: 'Falha ao carregar a lista de contas. Por favor, tente novamente mais tarde',
          changeCompaniesSectionWidth: 'Alterar largura da seção de empresas',
        },
        sidebar: {
          filterCompanies: 'Filtrar empresas',
          enterAtLeastNChatacters: 'Digite pelo menos {{length}} caracteres',
          placeholder: 'Digite a empresa ou e-mail',
          myCompany: 'Minha empresa',
          childCompanies: 'Empresas filhas',
          moreCompany: '{{count}} empresa a mais',
          moreCompanies: '{{count}} empresas a mais',
        },
        oldRoutes: {
          index: {
            noFacility: 'You do not have a facility defined',
            createAFacility: 'Create a facility to start planning routes',
            goToCreateAFacility: 'Go to create a facility',
            createAFacilityTooltip: 'You need to create a facility before you can start planning routes.',
            save: 'Save',
            reset: 'Reset',
            routePlans: 'Route Plans',
            loading: 'Loading...',
            noRoutesAdded: 'No routes added.',
            buildARouteTooltip: 'Build a route using the Route Builder.',
            createFloorplanSuccess: 'Success! Floorplan uploaded!',
            createRouteSuccess: 'Success! Route created!',
          },
          routeBuilder: {
            title: 'Route Builder',
            missingFields: 'Missing fields in the excel file',
            manuallyBuildARoute: 'Manually Build A New Route Plan',
            manualInstructions: 'You can build routes manually or by uploading an Excel file.',
            facility: 'Facility',
            route: 'Route',
            enterRoute: 'Enter Route',
            addFloorplan: 'Add Floorplan',
            floorplanInstructionsTooltip:
              'Add an image of a floorplan to help you build routes. The route will be superimposed on the floorplan when saved.',
            change: 'Change',
            location: 'Location',
            enterLocation: 'Enter Location',
            equipment: 'Equipment',
            enterEquipment: 'Enter Equipment',
            criticality: 'Criticality',
            enterCriticality: 'Enter Criticality',
            description: 'Description',
            enterDescription: 'Enter Description',
            addEquipment: 'Add Equipment',
            addRoute: 'Add Route',
            downloadTemplate: 'Download Template',
          },
          excelReader: {
            loadFromFile: 'Load From File',
            instructionsTooltip:
              'You can build routes by uploading an Excel file where each sheet represents a different location in a facility. Each location can have multiple routes.',
          },
          graph: {
            controls: {
              addFloorplan: 'Add Floorplan',
              toggleLabels: 'Toggle Labels',
              addWaypoint: 'Add Waypoint',
              addEquipment: 'Add Equipment',
              swapEquipment: 'Swap Equipment',
              showLeakStats: 'Show Record Stats',
              save: 'Save',
              delete: 'Delete',
            },
            routeStats: {
              title: 'Route Statistics',
              totalDollarLossPerYear: 'Total $ Loss Per Year:',
              totalKwhLossPerYear: 'Total Kwh Loss Per Year:',
              totalLeakCount: 'Total Record Count:',
              totalActiveOpen: 'Total Active Open:',
              totalActiveClosed: 'Total Active Closed:',
              noStatsAvailable: 'No statistics available:',
              close: 'Close',
            },
            nodeDetails: {
              edit: 'Edit',
              name: 'Name',
              description: 'Description',
              criticality: 'Criticality',
              equipmentInformation: 'Equipment Information',
              thisIsAWaypoint: 'This is a waypoint',
              activeOpenLeakCount: 'Active Open Record Count:',
              noActiveLeaksDetected: 'No active leaks detected',
              close: 'Close',
              nothingToSeeHere: 'Nothing to see here',
              seeLeakRecords: 'See Records',
            },
            swapEquipment: {
              title: 'Swap Equipment',
              selectEquipment: 'Select the equipment to swap:',
              selectFirst: 'Select the first equipment',
              selectSecond: 'Select the second equipment',
              swap: 'Swap',
              cancel: 'Cancel',
            },
            addNode: {
              title: 'Add',
              waypoint: 'Waypoint',
              equipment: 'Equipment',
              afterWhich: 'After which equipment?',
              selectPreceding: 'Select the preceding equipment:',
              selectEquipment: 'Select equipment',
              name: 'Name',
              description: 'Description',
              criticality: 'Criticality',
              add: 'Add',
              cancel: 'Cancel',
            },
            save: 'Save',
            delete: 'Delete',
            successRouteUpdated: 'Route updated successfully',
            errorRouteUpdated: 'Error updating route. Please try again later.',
            successRouteDeleted: 'Route deleted successfully',
            errorRouteDeleted: 'Error deleting route. Please try again later.',
            successFloorplanUpdated: 'Floorplan updated successfully',
            errorFloorplanUpdated: 'Error updating floorplan. Please try again later.',
          },
        },
        routes: {
          commonUsedWords: {
            equipmentNameIsRequired: 'O nome do equipamento é obrigatório',
            equipmentLocationIsRequired: 'A localização do equipamento é obrigatória',
            equipmentCriticalityIsRequired: 'A criticidade do equipamento é obrigatória',
            equipmentDescriptionIsRequired: 'A descrição do equipamento é obrigatória',
            name: 'Nome',
            description: 'Descrição',
            location: 'Localização',
            criticality: 'Criticidade',
            actions: 'Ações',
          },
          index: {
            routePlans: 'Planos de rota',
            addRoute: 'Adicionar rota',
            routeRoutesExample: 'Exemplo de rotas',
            pieceOfEquipment: '{{count}} equipamento',
            piecesOfEquipment: '{{count}} equipamentos',
            equipment: 'Equipamento',
            metrics: 'Métricas',
            settings: 'Configurações',
            noFloorPlan: 'Você não enviou um plano de piso para esta rota',
            addFloorPlan: 'Adicione um plano de piso para começar a planejar visualmente sua rota',
            routeEquipment: 'Equipamentos da rota',
            routeMetrics: 'Métricas da rota',
            metricsForRoute: 'Métricas da rota',
            totalRecords: 'Total de registros',
            totalOpenRecords: 'Total de registros abertos',
            totalClosedRecords: 'Total de registros fechados',
            totalLossPerYear: 'Perda total por ano',
            totalKwhPerYear: 'Total de kWh por ano',
            routeUpdatedSuccessfully: 'Rota atualizada com sucesso',
            routeRemovedSuccessfully: 'Rota removida com sucesso',
            routeSettings: 'Configurações da rota',
            removeRoute: 'Remover rota',
            deleteRouteWarning:
              'Remover esta rota excluirá a rota, os equipamentos da rota e o histórico da rota do sistema, mas deixará os dados históricos associados aos registros.',
            areYouSure: 'Tem certeza de que deseja remover esta rota?',
            warningRemovingRoute: 'Remover a rota exclui permanentemente a rota, seus equipamentos e seu histórico do sistema.',
            thisActionCannotBeUndone: 'ESSA AÇÃO NÃO PODE SER DESFEITA.',
            noFacility: 'Você não tem uma instalação definida',
            createAFacility: 'Crie uma instalação para começar a planejar rotas',
            goToCreateAFacility: 'Ir para criar uma instalação',
            createAFacilityTooltip: 'Você precisa criar uma instalação antes de começar a planejar rotas.',
          },
          routeBuilder: {
            title: 'Construtor de rotas',
            missingFields: 'Campos ausentes no arquivo enviado',
            facility: 'Instalação',
            route: 'Rota',
            enterRoute: 'Insira a rota',
            addFloorplan: 'Adicionar planta baixa',
            floorplanInstructionsTooltip:
              'Adicione uma imagem de uma planta baixa para ajudar a construir rotas. A rota será sobreposta à planta baixa quando salva.',
            change: 'Alterar',
            location: 'Localização',
            enterLocation: 'Insira a localização',
            equipment: 'Equipamento',
            enterEquipment: 'Insira o equipamento',
            criticality: 'Criticidade',
            enterCriticality: 'Insira a criticidade',
            description: 'Descrição',
            enterDescription: 'Insira a descrição',
            addEquipment: 'Adicionar equipamento',
            addRoute: 'Adicionar rota',
            downloadTemplate: 'Baixar modelo',
            excelTemplate: 'Modelo Excel (.xlsx)',
            csvTemplate: 'Modelo CSV (.csv)',
          },
          fileReader: {
            loadFromFile: 'Carregar de arquivo',
            instructionsTooltip:
              'Você pode importar equipamentos enviando um arquivo Excel (.xlsx, .xls) ou CSV (.csv). O arquivo deve conter as colunas: equipment_name, equipment_location, equipment_criticality, equipment_description. Baixe o modelo fornecido para começar.',
          },
          addRouteModal: {
            addRouteFor: 'Adicionar rota para {{facilityName}}',
            giveYourNewRouteAName: 'Dê um nome à sua nova rota, descreva sua localização na instalação e adicione o primeiro equipamento',
            routeNameIsRequired: 'O nome da rota é obrigatório',
            routeLocationIsRequired: 'A localização da rota é obrigatória',
            routeName: 'Nome da rota',
            routeLocation: 'Localização da rota',
            firstPieceOfEquipment: 'Primeiro equipamento',
            equipmentName: 'Nome do equipamento',
            equipmentCriticality: 'Criticidade do equipamento',
            equipmentLocation: 'Localização do equipamento',
            equipmentDescription: 'Descrição do equipamento',
            locationTooltip: 'Explique onde isso está localizado na instalação',
            equipmentLocationTooltip: 'Explique onde isso está localizado na rota',
            criticalityTooltip: 'Atribua uma classificação de criticidade ao equipamento (ECR), geralmente um valor entre 1 e 5',
            downloadTemplate: 'Baixar modelo',
            downloadCsvTemplate: 'Baixar modelo CSV',
            downloadExcelTemplate: 'Baixar modelo Excel',
            manual: 'Manual',
            import: 'Importar',
            importedEquipments: 'Equipamentos importados',
            pleaseImportEquipment: 'Por favor, importe equipamentos ou mude para o modo manual',
            equipmentOrderNote: 'Os equipamentos serão adicionados à rota na mesma ordem em que aparecem no seu arquivo.',
            addFloorplan: 'Adicionar planta baixa',
            change: 'Alterar',
            floorplan: 'Planta baixa',
            noValidEquipmentDataFound: 'Foram encontrados dados de equipamento inválidos no arquivo. Consulte o modelo.',
            equipmentItemsImportedSuccessfully: '{{count}} itens de equipamento importados com sucesso',
            invalidFileFormat: 'Formato de arquivo inválido. Por favor, use o modelo fornecido.',
            floorplanUploadedSuccessfully: 'Planta baixa enviada com sucesso',
            routeCreatedSuccessfully: 'Rota criada com sucesso',
            equipment: 'Equipamento',
            equipments: 'Equipamentos',
            addEquipmentBefore: 'Adicionar equipamento antes',
            addEquipmentAfter: 'Adicionar equipamento depois',
            addEquipmentBetween: 'Adicionar equipamento entre',
            removeEquipment: 'Remover equipamento',
            floorplanIsRequired: 'A planta baixa é obrigatória',
          },
          routeViewer: {
            showLabels: 'Mostrar rótulos',
            hideLabels: 'Ocultar rótulos',
            zoomIn: 'Ampliar',
            zoomOut: 'Reduzir',
            resetZoom: 'Redefinir zoom',
            centerView: 'Centralizar visão',
            panUp: 'Para cima',
            panDown: 'Para baixo',
            panLeft: 'Esquerda',
            panRight: 'Direita',
          },
          routeEditorAddEquipmentAction: {
            addingNewEquipment: 'Adicionar um novo equipamento o insere na rota após o equipamento selecionado.',
            addEquipment: 'Adicionar equipamento',
          },
          routeEditorAddWaypointAction: {
            waypoint: 'Ponto de passagem',
            addingNewWaypoint:
              'Adicionar um novo ponto de passagem insere uma mudança de direção na rota após o equipamento selecionado, mas não é uma etapa ao executar a rota.',
            addWaypoint: 'Adicionar ponto de passagem',
          },
          routeEditorEditEquipmentAction: {
            updateEquipment: 'Atualizar equipamento',
          },
          routeEditorEditFloorPlan: {
            floorPlan: 'Planta baixa',
            chooseFloorplan: 'Escolher planta baixa',
          },
          routeEditorModal: {
            successRouteUpdated: 'Rota atualizada com sucesso',
            errorRouteUpdated: 'Erro ao atualizar a rota. Por favor, tente novamente mais tarde.',
            successRouteDeleted: 'Rota excluída com sucesso',
            errorRouteDeleted: 'Erro ao excluir a rota. Por favor, tente novamente mais tarde.',
            successFloorplanUpdated: 'Planta baixa atualizada com sucesso',
            errorFloorplanUpdated: 'Erro ao atualizar a planta baixa. Por favor, tente novamente mais tarde.',
            unsavedChanges: 'Você tem alterações não salvas. Tem certeza de que deseja sair?',
            back: 'Voltar',
            editEquipment: 'Editar equipamento',
            youHaventUploadedFloorPlan: 'Você não enviou uma planta baixa. Desbloqueie a edição visual enviando uma planta baixa hoje.',
            addFloorPlan: 'Adicionar planta baixa',
            addNewEquipment: 'Adicionar novo equipamento',
            removeEquipment: 'Remover equipamento',
            swapEquipment: 'Trocar equipamento',
            addWaypoint: 'Adicionar ponto de passagem',
            changeFloorplan: 'Alterar planta baixa',
            actions: {
              ADD_EQUIPMENT: 'Adicionar equipamento',
              DELETE_NODE: 'Excluir nó',
              SWAP_EQUIPMENT: 'Trocar equipamento',
              ADD_WAYPOINT: 'Adicionar ponto de passagem',
              CHANGE_FLOORPLAN: 'Alterar planta baixa',
            },
          },
          routeEditorRemoveEquipmentAction: {
            youAreAboutToRemoveEquipmentFromTheRoute: 'Você está prestes a remover o seguinte equipamento da rota.',
            youAreAboutToRemoveWaypointFromTheRoute: 'Você está prestes a remover o ponto de passagem selecionado da rota.',
            youWillNotLoseAnyHistoricalData:
              'Você não perderá nenhum dado histórico, mas este {{type}} será removido da rota e não estará disponível para execuções futuras.',
            equipment: 'equipamento',
            waypoint: 'ponto de passagem',
          },
          routeEditorSwapEquipmentAction: {
            replacementEquipmentIsRequired: 'O equipamento de substituição é obrigatório',
            swappingEquipmentExplanation: 'Trocar equipamento substitui a posição do equipamento selecionado por outro equipamento.',
            swappingEquipmentCaption: 'Isso não afeta os dados históricos, mas mudará a ordem dos equipamentos na rota.',
            selectedEquipment: 'Equipamento selecionado',
            swapWith: 'Trocar com',
            selectEquipment: 'Selecionar equipamento',
            swapEquipment: 'Trocar equipamento',
          },
        },
      },
      companySettings: {
        settings: {
          adminLicenses: {
            aal: 'Licenças de administrador atribuídas',
            of: 'de',
            edit: 'Editar',
          },
          essentialMode: {
            disable: 'desativar',
            enable: 'ativar',
            essential: 'Modo Essential:',
            enabled: 'ATIVADO',
            disabled: 'DESATIVADO',
            moveCompany: 'Mover a empresa {{company}} para o Modo Essential',
            affectedCompanies: 'Número de empresas afetadas',
            affectedAccounts: 'Número de contas afetadas',
            archivedLeak: 'Número de registros de eventos de vazamento arquivados',
            applyingChanges:
              'Ao aplicar essas alterações, as contas obterão a função “Essential”. Os usuários poderão ver os {{quota}} registros mais recentes de eventos de vazamento em um painel e no aplicativo móvel. Os demais registros serão arquivados.',
            essentialLabel: 'Alterar Essential para subempresas',
            turnOffEssential: 'Desativar o Modo Essential para a empresa {{company}}',
            byApplyingChanges:
              'Ao aplicar essas alterações, todas as contas obterão a função “Usuário”. Os usuários poderão ver todos os seus registros. Todos os registros serão desarquivados.',
          },
          hubspotSync: {
            disable: 'desativar',
            enable: 'ativar',
            hubspot: 'Sincronização HubSpot',
            enabled: 'ATIVADO',
            disabled: 'DESATIVADO',
            enableHubspotSync: 'Ativar sincronização HubSpot para a empresa {{company}}',
            disableHubspotSync: 'Desativar sincronização HubSpot para a empresa {{company}}',
            affectedCompanies: 'Número de empresas afetadas',
            applyingChanges: 'Ao aplicar essas alterações, a sincronização com o HubSpot será {{status}}.',
            hubspotLabel: 'Alterar sincronização HubSpot para subempresas',
          },
          convertToSuperCompany: {
            title: 'Reestruturar empresa',
            newParentCompany: 'Nova empresa-mãe',
            confirmChange: 'Confirmar nova estrutura da empresa',
            confirmChangeMessage: 'Tem certeza de que deseja converter {{child}} em empresa filha de {{parent}}?',
            convertSuccess: 'Empresa reestruturada com sucesso',
            convertError: 'Erro ao reestruturar a empresa. Por favor, tente novamente mais tarde.',
          },
          index: 'Configurações',
        },
        index: {
          loadCompanyError: 'Não é possível carregar as informações da empresa. Por favor, tente novamente mais tarde',
          companySlug: 'Slug da empresa',
          notSelected: 'Não selecionado',
          country: 'País',
          accounts: 'Contas',
          currency: 'Moeda',
          adminLicenses: 'Licenças de administrador',
          totalCustomer: 'Total de contas de clientes na árvore',
        },
      },
      device: {
        registerDeviceView: {
          registerDevice: 'Registrar seu dispositivo',
          toolTip: 'Por favor, localize o número de série no seu cartão de registro ou na caixa.',
          serialNumberIsRequired: 'O número de série é obrigatório',
          oops: 'Ops!',
          deviceNotFound: 'Número de série do dispositivo não encontrado',
          deviceFoundNdAssociatedCompany: 'Seu dispositivo foi encontrado e está associado a uma empresa.',
          deviceFound: 'Seu dispositivo foi encontrado.',
          goToLogin: 'Ir para login',
          contactSupport: 'Por favor, entre em contato com o suporte',
        },
        deviceErrorCodes: {
          'B13:001': 'Número de série do dispositivo não encontrado',
          'B13:002': 'Dispositivo já ativado',
          'B13:003': 'E-mail do administrador não enviado',
          'B13:004': 'Empresa não encontrada',
          'B13:005': 'Empresa inválida',
          'B13:006': 'Tipo inválido',
        },
        registerAccountView: {
          createAccountSuccess: 'Conta criada com sucesso',
          createAccountError: 'Erro ao criar conta. Por favor, entre em contato com support@prosaris.ca',
          registerAccount: 'Criar uma conta',
          termsMustBeAccepted: 'Os termos e condições devem ser aceitos.',
          saleType012Success: 'Você pode fazer login para começar a usar seu dispositivo.',
          saleType3Success: 'Você foi adicionado como usuário básico. Seus administradores da empresa foram notificados.',
          saleType4Success: {
            companyPlatformFound: 'Licença da plataforma da empresa encontrada.',
            dialogOne: 'Este dispositivo está associado a uma nova licença da plataforma da empresa.',
            dialogTwo: 'Sua empresa pode já existir em nosso sistema.',
            dialogThree: 'Se sim, por favor, entre em contato com o seu administrador.',
          },
          termsAndConditions: {
            dialogOne: 'Eu concordo com os',
            dialogTwo: 'Termos de Serviço',
            dialogThree:
              'e confirmo que tive tempo suficiente para lê-los e entendo que contêm termos importantes sobre o meu uso do software da Prosaris, como a limitação da responsabilidade da Prosaris e como meus dados serão tratados.',
          },
          termsOfServiceModal: {
            termsOfService: 'Termos de Serviço',
          },
          acceptTerms: 'Aceitar termos',
          registerAccountErrorCodes: {
            'B02:001': 'Código de registro inválido',
            'B02:002': 'Empresa do usuário inválida',
            'B02:003': 'Função do usuário inválida',
            'B02:004': 'E-mail já está em uso',
            'B02:005': 'E-mail já está em uso',
            'B02:006': 'Não foi possível redefinir a senha da sua conta',
            'B02:007': 'Empresa do usuário inválida',
            'B02:008': 'Foto de perfil ausente',
            'B02:009': 'É necessário redefinir a conta. O processo foi iniciado',
            'B02:010': 'A conta foi desativada',
            'B02:011': 'Formato de foto de perfil inválido',
            'B02:012': 'Dispositivo já registrado em uma empresa',
            'B02:013': 'Número de série indefinido',
            'B02:014': 'Tipo inválido',
            'B02:015': 'Link de redefinição de senha expirado',
            'B02:016': 'Não é possível criar uma conta para esta empresa',
            'B02:017': 'Função inválida',
            'B02:018': 'Função inválida',
            'B02:019': 'Empresa do usuário inválida',
            'B02:020': 'Função do usuário inválida',
            'B02:021': 'O usuário não pertence a esta empresa',
          },
          whichProduct: 'Qual produto você possui?',
        },
        devicesView: {
          serialNumbersIsReq: 'Os números de série são obrigatórios',
          failedToCopy: 'Números de série com falha copiados para a área de transferência',
          invalidFormat: 'Um ou mais dispositivo(s) estão em formato inválido. Por favor, verifique e tente novamente.',
          devices: 'Registrar seus dispositivos',
          deviceSerialNumber: 'Número(s) de série do dispositivo',
          note: 'Digite cada número de série em uma nova linha ou separado por vírgula.',
          title: 'Por favor, localize o número de série no seu cartão de registro ou na caixa.',
          register: 'Registrar',
          deviceRegistrationStatus: 'Status de registro do dispositivo',
          success: 'Sucesso',
          noDeviceFound: 'Nenhum dispositivo encontrado.',
          failed: 'Falha',
          copyFailed: 'Copiar números de série com falha para a área de transferência',
        },
      },
      errors: {
        notFoundView: {
          title: 'A página que você está procurando não está aqui',
          description: 'Você tentou acessar uma rota suspeita ou chegou aqui por engano. Seja qual for o caso, tente usar a navegação',
        },
        accountNotFound: {
          title: 'Conta não encontrada',
          description:
            'Por favor, tente novamente! Se o problema persistir, sua conta pode estar inativa ou não ter sido inicializada pelo administrador. Entre em contato com o seu administrador.',
          logout: 'Sair',
        },
      },
      integration: {
        index: {
          loggingInError: 'Erro ao entrar no Prosaris.',
        },
      },
      leakRecordDetails: {
        assignedActions: {
          actionImages: 'Nenhuma imagem disponível',
          activeActionRecord: {
            updateAssignmentSuccess: 'A ação atribuída foi atualizada.',
            updateAssignmentError: 'Erro ao atualizar a ação atribuída.',
            deleteImageSuccess: 'A imagem atribuída foi excluída.',
            deleteImageError: 'Erro ao excluir a imagem atribuída à ação.',
            confirmMarkAction:
              'Concluir esta atribuição marcará o registro como concluído e todas as suas ações associadas como inativas. Você realmente deseja continuar?',
            confirmDeleteImage: 'Você realmente deseja excluir esta imagem?',
          },
          index: 'Erro ao carregar as ações atribuídas de um registro.',
        },
        audio: {
          noAudioAvailable: 'Nenhum dado de áudio disponível',
          errorDownloadingAudio: 'Erro ao baixar o áudio. Por favor, tente novamente mais tarde.',
          playPause: 'Reproduzir / Pausar',
          generateRegion: 'Gerar região',
          removeLastRegion: 'Remover última região',
          generateMarker: 'Gerar marcador',
          removeLastMarker: 'Remover último marcador',
          toggleTimeline: 'Alternar linha do tempo',
          download: 'Baixar',
        },
        audit: {
          updateAuditSuccess: 'Auditoria atualizada com sucesso',
          updateAuditError: 'Erro ao salvar o comentário. Por favor, tente novamente mais tarde.',
          createAuditSuccess: 'Auditoria criada com sucesso',
          createAuditError: 'Erro ao criar auditoria. Por favor, tente novamente mais tarde.',
          deleteAuditSuccess: 'Auditoria excluída com sucesso',
          deleteAuditError: 'Falha ao excluir a auditoria. Por favor, tente novamente mais tarde.',
          noComment: 'Nenhum comentário',
          reviewComments: 'Revisar comentários',
          reviewedBy: 'Revisado por:',
          auditDate: 'Data da auditoria:',
          deleteAudit: 'Excluir auditoria',
          reviewedNoComments: 'Revisado sem comentários',
          auditComments: 'Comentários da auditoria',
          saveComment: 'Salvar comentário',
          discardChanges: 'Descartar alterações',
        },
        changeHistory: {
          created: 'criado',
          updated: 'atualizado',
          deleted: 'excluído',
          synced: 'sincronizado',
          transferred: 'transferido',
          leak: 'Registro',
          images: 'Imagem',
          audit: 'Auditoria',
          audio: 'Áudio',
          history: 'Histórico',
          noHistory: 'Sem histórico',
          bulk: 'como uma operação em massa',
          details: 'detalhes',
          unset: 'não definido',
        },
        fft: {
          fft: 'FFT',
          fftAvg: 'Média FFT',
          notApplicable: 'N/A',
          chartLayers: 'camadas do gráfico',
          avg: 'Média',
          all: 'Todos',
          playing: 'Reproduzindo...',
          showTimeSeries: 'Mostrar série temporal',
        },
        form: {
          updateLeakSuccess: 'Atualizado com sucesso.',
          updateLeakError: 'Erro ao atualizar o vazamento. Por favor, tente novamente mais tarde.',
          alertTitle: {
            partOne: 'O registro está em',
            partTwo: 'somente leitura',
            partThree: 'modo.',
          },
          alertDialog: {
            dialogOne: 'No entanto, as seguintes propriedades podem ser modificadas:',
            dialogTwo: 'Status da ação',
          },
          GPSLocation: 'Localização GPS',
          completedOn: 'Concluído em:',
          lastSaved: 'Última gravação:',
          updateConfirmMessage: 'Concluir este registro marcará todas as ações associadas como inativas. Você realmente deseja continuar?',
          updateConfirmTitle: 'Confirmar conclusão do registro',
          smartTagHelp: 'Saiba mais sobre os Smart Tags da PROSARIS',
        },
        images: {
          removeSuccess: 'Imagem excluída com sucesso.',
          removeError: 'Não é possível excluir a imagem do registro de vazamento. Por favor, tente novamente mais tarde',
          text: 'Tem certeza de que deseja excluir esta imagem?',
        },
        index: {
          title: 'Registro',
          loadingError: 'Erro ao carregar o registro de vazamento. Por favor, tente novamente.',
          unsavedMessage: "Ao pressionar 'Ok', você confirma que todas as alterações não salvas serão excluídas",
          notAnAuditor: 'Você não é um auditor',
          anEssential: 'Você está em um plano Essential',
          showHistory: 'Mostrar histórico',
        },
        massFlow: {
          recalculating: 'Recalculando fluxo/perda de acordo com as configurações dos parâmetros de vazamento...',
          warning:
            'Os valores de entrada foram alterados ou o cálculo está desatualizado, clique em `Recalcular` para atualizar os valores de fluxo e perda',
          calculatingError: 'Erro ao calcular o fluxo mássico. Por favor, tente novamente.',
          noValue: 'Nenhum valor',
          calculatingSuccess: 'Fluxo/perda recalculado',
          recalculate: 'Recalcular',
          calculatorVersion: 'Versão do cálculo:',
          noteDialog: {
            dialogOne: 'Alterar as configurações dos parâmetros de vazamento atualizará o cálculo de Fluxo/Perda. Verifique a',
            dialogTwo: 'página de insights de cálculo',
            dialogThree: 'para informações adicionais',
          },
        },
        unsavedWarningDialog: {
          recordChanged: 'O registro foi alterado',
          close: 'fechar',
          unsavedChanges:
            'Este registro possui alterações não salvas. Por favor, considere salvar essas alterações ou removê-las completamente.',
          discardChanges: 'Descartar alterações',
        },
      },
      leakRecordCreate: {
        form: {
          deviceIDIsRequired: 'O ID do dispositivo é obrigatório',
          dbPeakIsRequired: 'O pico de dB medido é obrigatório',
          dbMin: 'O pico de dB medido deve ser maior ou igual a 0',
          dbMax: 'O pico de dB medido deve ser menor ou igual a 95',
          dbError: 'O pico de dB medido deve ser um número',
          imageUploadError: 'Erro ao enviar a imagem. Por favor, tente novamente mais tarde.',
          createLeakSuccess: 'Registro adicionado com sucesso',
          createLeakError: 'Erro ao criar o registro. Por favor, tente novamente mais tarde.',
          basicInfo: 'Informações básicas',
          flowInput: 'Entrada de fluxo',
          mainGas: 'Gás/Componente principal de interesse',
          selectComponent: 'Selecionar componente',
          selectLeakType: 'Selecionar tipo de vazamento',
          mightBeSomethingHere: 'ainda não tenho certeza',
          energyLoss: 'Perda de energia',
          selectCompressorType: 'Selecionar tipo de compressor',
          noRoutes: 'Nenhuma rota encontrada',
          noEquipment: 'Nenhum equipamento encontrado',
          noLocations: 'Nenhuma localização encontrada',
          energyCost: 'Custo de energia',
          audioRecording: 'Gravação de áudio',
          leakSourceEquipment: 'Fonte',
          selectComponentType: 'Selecionar tipo de componente',
          selectService: 'Selecionar serviço',
          locationAndUser: 'Localização e usuário',
          leakEventStatus: 'Status do evento',
          low: 'Baixo',
          medium: 'Médio',
          high: 'Alto',
          open: 'Aberto',
          complete: 'Concluído',
          reset: 'Redefinir',
        },
        formElectrical: {
          systemVoltages: 'Tensões do sistema',
          source: 'Fonte',
        },
        images: {
          leakSourceImageCapture: 'Captura de imagem da fonte',
          add: 'Adicionar',
        },
        index: {
          title: 'Criar registro',
        },
      },
      leakRecordsList: {
        filters: {
          from: 'De',
          to: 'Até',
          qualifier: 'Qualificador',
          savedFilters: 'Filtros salvos',
          filter: 'Filtro',
          selectFilter: 'Selecione um filtro...',
          filterName: 'Nome do filtro',
          filterNameRequired: 'O nome do filtro é obrigatório',
          filtersNotAvailable: 'Filtros não disponíveis',
          saveFilterTitle: 'Salvar filtro',
          deleteSavedFilterTitle: 'Por favor, confirme a exclusão do filtro',
          deleteSavedFilterMessage: 'Tem certeza de que deseja excluir o filtro "{{savedFilterName}}"?',
          createFilterSuccess: "Filtro '{{filter}}' criado com sucesso. Você pode acessá-lo em Filtros de Registro → Filtros Salvos",
          createFilterError: 'Erro ao criar filtro. Por favor, tente novamente mais tarde.',
          deleteFilterSuccess: 'Filtro excluído com sucesso',
          deleteFilterError: 'Erro ao excluir filtro. Por favor, tente novamente mais tarde.',
          emptyFilter: 'Está vazio',
        },
        modalAssignUsers: {
          assignLeakRecord: 'Atribuir registro',
          selectAUserToAssign: 'Selecione um usuário que deve ser atribuído ao(s) registro(s) selecionado(s)',
          filterByName: 'Filtrar por nome',
          filterByEmployeeName: 'Filtrar por nome do funcionário',
          unexpectedError: 'Ocorreu um erro inesperado',
          noUserFound: 'Nenhum usuário encontrado',
          assigningActionForSelectedRecords: 'Atribuindo ação para o(s) registro(s) selecionado(s)...',
        },
        modalTransferRecords: {
          transferRecords: 'Transferir registros',
          selectCompany: 'Selecionar empresa',
          selectCompanyPlaceholder: 'Selecione uma empresa',
          selectUser: 'Selecionar usuário',
          selectUserPlaceholder: 'Selecione um usuário',
          noUserFound: 'Nenhum usuário encontrado',
          unexpectedError: 'Ocorreu um erro inesperado',
        },
        modalBulkEdit: {
          titleSingleRecord: 'Edição em massa de {{selectedRecordsCount}} registro',
          title: 'Edição em massa de {{selectedRecordsCount}} registros',
          selectAField: 'Selecione um campo',
          verifyAction:
            'Você está prestes a atualizar registros que pertencem a outros usuários. Por favor, confirme digitando abaixo o número de registros selecionados.',
          matchCountError: 'Deve corresponder ao número de registros selecionados ({{selectedRecordsCount}})',
          moreThanOneType:
            'Os registros selecionados têm mais de um tipo de registro. Alguns campos podem não estar disponíveis para edição em massa.',
        },
        tableHead: {
          youAreSelecting: 'Você está selecionando:',
          visibleRecords: 'registros visíveis',
          andAllUnloadedRecords: 'e todos os registros não carregados.',
          allRecordsWillBeLoaded: 'Todos os registros serão carregados e selecionados.',
          thisCanTakeAWhile: 'Isso pode levar algum tempo se você tiver muitos registros.',
          allRecords: 'Todos os registros, incluindo os invisíveis',
          selectAllRecords: 'Selecionar todos os registros.',
        },
        tableBody: {
          noRecordsToDisplay: 'Não há registros para exibir.',
        },
        toolBar: {
          assign: 'Atribuir',
          assignToSelf: 'Atribuir a mim',
          assignToSelfDialogTitle: 'Confirmar atribuição de registros',
          assignToSelfDialogMessage: 'Tem certeza de que deseja atribuir {{len}} registro(s) a si mesmo?',
          onEssentialPlan: 'Você está em um plano Essential. Por favor, entre em contato com support@prosaris.ca',
          bulkEdit: 'Edição em massa',
          transfer: 'Transferir',
          bulkEditSuccess: '{{len}} registro atualizado com sucesso',
          bulkEditSuccessPlural: '{{len}} registros atualizados com sucesso',
          bulkEditError: 'Erro ao atualizar registros. Por favor, tente novamente mais tarde',
          export: 'Exportar',
          exportPDF: 'Exportar PDF',
          needAdminLicense:
            'Você precisa de uma licença de administrador para acessar este recurso. Por favor, entre em contato com support@prosaris.ca',
          create: 'Criar',
          deleteRecordMessage: 'Tem certeza de que deseja excluir o registro selecionado?',
          deleteRecordMessagePlural: 'Tem certeza de que deseja excluir os registros selecionados?',
          permissionDenied: 'Permissão negada!',
          notAllowedToDelete:
            'Você selecionou o registro de outra pessoa, que não tem permissão para excluir. Por favor, remova-o da seleção.',
          generatingPDF: 'Gerando PDF...',
          csvExportProcessing: 'Seu arquivo está sendo processado. Ele será baixado automaticamente.',
          cannotGeneratePDF:
            'Infelizmente, não podemos exportar {{numberSelected}} registros em um único documento PDF no momento. Por favor, selecione até {{limitRecords}} registros.',
          cannotExportMessage: 'Não é possível exportar {{numberSelected}} registros',
          bulkEditLimitExceeded:
            'Não é possível editar mais de {{maxAllowed}} registros. Por favor, entre em contato com support@prosaris.ca',
          selectAtLeastOneRecord: 'Por favor, selecione pelo menos um registro',
        },
        index: {
          cannotLoadLeakRecord: 'Desculpe, não foi possível carregar o registro de vazamento agora',
          successfullyAssignedAllRecords: 'Todos os registros foram atribuídos com sucesso',
          actionRecordAssigned: 'Registro de ação atribuído!',
          actionRecordAssignedPlural: 'Registros de ação atribuídos!',
          errorWhileAssigningLeak: 'Erro ao atribuir vazamento. Por favor, tente novamente mais tarde.',
          successfullyDeletedAllRecords: 'Todos os registros foram excluídos com sucesso',
          successfullyDeletedRecord: '{{length}} registro de vazamento excluído com sucesso',
          successfullyDeletedRecordPlural: '{{length}} registros de vazamento excluídos com sucesso',
          errorOnRecordsDelete: 'Erro ao excluir registros. Por favor, tente novamente mais tarde',
          leakPreview: 'Pré-visualização',
          leakRecord: 'Registro: ',
          failedAssignments: 'Falhas nas atribuições ({{failed}})',
          failedAssignmentCodes: {
            'B04:012': 'O registro está fechado',
          },
          displayedRows: '{{from}}-{{to}} de {{count}}',
          rowsPerPage: 'Linhas por página:',
          previousPage: 'Página anterior',
          nextPage: 'Próxima página',
          csvExportSuccess: 'Exportação concluída com sucesso',
          csvExportError: 'Erro ao exportar. Por favor, tente novamente mais tarde.',
        },
      },
      tagList: {
        resetTag: 'Redefinir Tag',
        dataExport: {
          smartLeakTagsFormat: 'Formato de Smart Tags',
          smartLeakTagsDescription: 'Contém os campos padrão presentes na página de Smart Tags',
          standardLeakRecordFormat: 'Formato de registro padrão',
          standardLeakRecordDescription: 'Contém todos os campos relacionados aos registros de vazamento',
        },
        filters: { smartLeakTagFilters: 'Filtros de Smart Tag' },
        index: {
          cannotLoadTags: 'Desculpe, não foi possível carregar o Smart Tag agora',
          updateLeakSuccess: 'Smart Tag redefinido com sucesso.',
          updateLeakError: 'Erro ao redefinir o Smart Tag. Por favor, tente novamente mais tarde.',
          bulkEditSuccess: '{{len}} Smart Tag redefinido com sucesso',
          bulkEditSuccessPlural: '{{len}} Smart Tags redefinidos com sucesso',
          bulkEditError: 'Erro ao redefinir Smart Tags. Por favor, tente novamente mais tarde.',
          tagsFileName: 'Smart Tags',
          leakFileName: 'Registros',
        },
        tableBody: {
          title: 'Por favor, confirme a redefinição da tag',
          alertDialog: {
            dialogOne: 'Você está tentando',
            dialogTwo: 'redefinir a tag',
            dialogThree: 'de um registro de vazamento com',
            dialogFour: 'Status da ação: ABERTO',
            dialogFive: 'Deseja continuar?',
          },
        },
        toolBar: {
          resetTags: 'Redefinir tags',
          title: 'Por favor, confirme a redefinição em massa das tags',
          alertDialog: {
            dialogOne: 'Sua seleção contém',
            dialogTwo: 'registro com',
            dialogTwoPlural: 'registros com',
            dialogThree: 'Status da ação: ABERTO',
            dialogFour: 'Deseja continuar?',
          },
          exportFormatCSV: 'Selecione um formato de exportação para CSV',
          exportFormatPDF: 'Selecione um formato de exportação para PDF',
        },
      },
      myDashboard: {
        assignedActions: {
          index: {
            errorMessage: 'Erro ao carregar as ações atribuídas. Por favor, tente novamente.',
          },
        },
        charts: {
          chartFilters: {
            availableCharts: 'Gráficos disponíveis',
            selectAChart: 'Selecione um gráfico...',
            chartFilters: 'Filtros de gráfico',
          },
          charts: {
            errorMessages: {
              errorMessageOne: 'Erro ao carregar registros de vazamento. Por favor, tente novamente.',
              errorMessageTwo: 'Por favor, selecione uma data anterior à data de término.',
              errorMessageThree: 'Por favor, selecione um período de data inferior a 6 meses',
              errorMessageFour: 'Por favor, selecione uma data posterior à data de início.',
            },
            charts: 'Gráficos',
            chartAlreadyExists: 'Este gráfico já existe!',
          },
          filters: {
            select: 'Selecionar...',
            startDate: 'Data de início',
            endDate: 'Data de término',
          },
          utils: {
            chartsTitles: {
              FLOW_BY_LEAK: (unit) => `Fluxo por categoria de vazamento (${unit})`,
              LOSS_BY_LEAK: (currency) => `Perda por categoria de vazamento (${currency})`,
              TAGS_BY_LEAK: 'Tags por categoria de vazamento',
              AVG_FLOW_BY_LEAK: (unit) => `Fluxo médio por categoria de vazamento (${unit})`,
              SAVING_OPT_BY_REPAIR: (currency) => `Perda e oportunidade de economia por tempo de reparo (${currency})`,
              FLOW_REPAIR_TIME: (unit) => `Fluxo por tempo de reparo (${unit})`,
              LOSS_REPAIR_TIME: (currency) => `Perda por tempo de reparo (${currency})`,
              FLOW_REPAIR_PROG: (unit) => `Progresso do fluxo – Reparado x Não reparado (${unit})`,
              TOTAL_REPAIR_PROG: (currency) => `Progresso da perda – Reparado x Não reparado (${currency})`,
              FLOW_BY_EQUIP_COMP: (unit) => `Fluxo por equipamento/componente (${unit})`,
              LOSS_BY_EQUIP_COMP: (currency) => `Perda por equipamento/componente (${currency})`,
              TAGS_BY_EQUIP_COMP: 'Tags por equipamento/componente',
            },
            datasetLabel: {
              totalLeakFlow: 'Fluxo total de vazamentos encontrado em',
              totalLoss: 'Total de perdas',
              totalRecords: 'Total de registros encontrados',
              avgLeakFlow: 'Fluxo médio de vazamentos encontrado em',
              totalLossIn: 'Perda total em',
              flowByRepairTime: 'Fluxo por tempo de reparo em',
              lossByRepairTime: 'Perda por tempo de reparo',
              flowByRepairProgress: 'Fluxo encontrado por progresso de reparo em',
              recordsByCompletion: 'Registros por conclusão',
              flowByEquipment: 'Fluxo encontrado por equipamento em',
              totalLossByEquipment: 'Perda total por equipamento',
              totalRecordsByEquipment: 'Total de registros por equipamento',
            },
            labels: {
              low: 'Baixo',
              medium: 'Médio',
              high: 'Alto',
              equipment: 'Equipamento',
              savings: 'Economia',
              opportunity: 'Oportunidade',
              loss: 'Perda',
              repaired: 'Reparado',
              unrepaired: 'Não reparado',
              LESS_15_DAYS: 'Menos de 15 dias',
              DAYS_16_TO_30: '16 a 30 dias',
              DAYS_31_TO_60: '31 a 60 dias',
              DAYS_61_TO_90: 'Mais de 60 dias',
            },
          },
        },
        index: {
          assignedActions: 'Ações atribuídas a você',
        },
      },
      export: {
        imageUrlOne: 'URL da imagem do registro 1',
        imageUrlTwo: 'URL da imagem do registro 2',
        audioFileUrlOne: 'URL do arquivo de áudio',
        smartTag: 'Smart Tag',
        workRef: 'Ref. de trabalho',
        per: 'por ',
      },
      downloadApk: {
        pageTitle: 'PROSARIS - Baixar aplicativo',
        title: 'Baixar o aplicativo PROSARIS',
        mobileInstructions:
          'Se você estiver visualizando esta página em um tablet ou dispositivo móvel, toque no botão "Baixar" abaixo para baixar o aplicativo PROSARIS em seu dispositivo.',
        desktopInstructions:
          'Se você estiver visualizando esta página em um computador, escaneie o código QR com seu tablet ou dispositivo móvel e baixe o aplicativo a partir daí.',
        downloadButton: 'Baixar',
        qrCodeLabel: 'Baixar aplicativo PROSARIS',
        additionalInstructions: {
          title: 'Instruções adicionais de download',
          description:
            'Você está baixando um APK (Android Package Kit) de um site e pode encontrar medidas de segurança adicionais em comparação com um download na Google Play.',
          step1: 'Pode aparecer um aviso dizendo "Este arquivo pode ser prejudicial". Toque em "Baixar mesmo assim".',
          step2:
            'Seu dispositivo pode avisar que "não é permitido instalar aplicativos desconhecidos desta fonte". Você será solicitado a abrir as configurações do dispositivo.',
          step3: 'Na página de configurações, ative a opção para permitir downloads de aplicativos desconhecidos.',
          step4:
            'Você pode ser solicitado a "Verificar aplicativo" como medida de segurança final. Após a verificação, será solicitado o download do aplicativo.',
        },
      },
    },
    languages: {
      English: 'Inglês',
      Chinese: 'Chinês',
      Spanish: 'Espanhol',
      French: 'Francês',
      German: 'Alemão',
      Norwegian: 'Norueguês',
      Italian: 'Italiano',
      Turkish: 'Turco',
      Japanese: 'Japonês',
      Portuguese: 'Português',
      Korean: 'Coreano',
    },
  },
};
